module.exports    = {
	"language": "语言",
	"hello": "世界 {{.a}}",
	"c001": "Erreur réseau, veuillez réessayer plus tard ! ",
	"c002": "Quitter",
	"c003": "Se connecter",
	"c004": "Veuillez entrer un nom d'utilisateur",
	"c005": "Veuillez entrer le mot de passe de connexion",
	"c006": "Enregistrer",
	"c007": "Le compte ou le mot de passe que vous avez saisi est incorrect",
	"c008": "Compte",
	"c009": "Langue",
	"c010": "Total",
	"c011": "pièce",
	"c012": "Bonjour,",
	"c013": "Votre compte n'est pas activé, veuillez contacter l'administrateur",
	"c014": "Votre compte a été gelé, veuillez contacter l'administrateur",
	"c015": "Réinitialiser",
	"c016": "Échec de la connexion WebSocket",
	"c017": "Erreur interne",
	"c018": "Vous n'avez pas les autorisations nécessaires pour effectuer cette action",
	"c019": "L'utilisateur actuel n'a pas les droits nécessaires pour accéder à cette page",
	"c020": "Les informations de connexion ont expiré, veuillez vous reconnecter !",
	"c021": "Connexion de l'utilisateur",
	"c022": "Documentation",
	"c023": "qualifié",
	"c024": "mauvais",
	"c025": "résultats",
	"c026": "système",
	"c027": "connexion anormale à la base de données, veuillez vérifier.  le",
	"c028": "exception d'initialisation de base de données, veuillez vérifier",
	"m001": "Hors ligne",
	"m002": "En ligne",
	"m003": "Anomalie",
	"m004": "Supprimé",
	"m005": "Ajouter un appareil",
	"m006": "Éditer l'équipement",
	"m007": "Gestion des équipements",
	"m008": "Numéro",
	"m009": "État",
	"m010": "Numéro de l'équipement",
	"m011": "Nom de l'équipement",
	"m012": "Ligne de production associée",
	"m013": "Trier",
	"m014": "Adresse IP",
	"m015": "Adresse postale",
	"m016": "Remarque",
	"m017": "Date de mise à jour",
	"m018": "Opération",
	"m019": "Éditer",
	"m020": "Édition de l'équipement réussie",
	"m021": "Ajout de l'appareil réussi",
	"m022": "Nom d'appareil, numéro d'appareil ou adresse IP en double",
	"m023": "Le nom de l'équipement ne peut pas être vide et doit faire au moins 2 caractères",
	"m024": "Le numéro de l'équipement ne peut pas être vide et doit comporter au moins 2 caractères",
	"m025": "L'adresse IP ne peut pas être vide",
	"m026": "Le port doit être un nombre entier et ne pas dépasser 5 chiffres",
	"m027": "Supprimer",
	"m028": "Restaurer",
	"m029": "Port",
	"m030": "Démarrer la connexion automatique",
	"m031": "Note : L'adresse postale doit correspondre à celle dans le programmeur de la machine à souder",
	"m032": "Toutes les lignes de production",
	"m033": "Tous les états",
	"m034": "Veuillez sélectionner",
	"m035": "En ligne",
	"m036": "Hors ligne",
	"m037": "Suppression de l'appareil anormal, veuillez réessayer plus tard",
	"m038": "Anomalie de l'appareil, veuillez réessayer plus tard",
	"m039": "Suppression de l'appareil réussie",
	"m040": "Réussite du rétablissement de l'équipement",
	"m041": "Erreur lors de la récupération des données de l'appareil, veuillez réessayer plus tard",
	"m042": "Format d'adresse IP incorrect",
	"m043": "L'adresse postale doit être un nombre entier et ne pas dépasser 5 chiffres",
	"m044": "Veuillez sélectionner la ligne de production correspondante",
	"m045": "Échec de l'édition de l'équipement",
	"m046": "Ajout de l'appareil échoué",
	"m047": "Le nom de l'équipement est en double, veuillez le modifier",
	"m048": "Le numéro d'appareil est en double, veuillez le modifier",
	"m049": "L'adresse IP est en double, veuillez la modifier",
	"m050": "Collecter la courbe de courant",
	"m051": "Collecte de la courbe de tension",
	"m052": "Collecter la courbe de résistance",
	"m053": "Collecte de la courbe de pression",
	"m054": "Connexion automatique",
	"m055": "Expliquer l'erreur d'importation du fichier",
	"m056": "Erreur lors de la lecture du fichier téléchargé",
	"m057": "Extension de fichier incorrecte (.xlsx;.xlsm;.xltx)",
	"m058": "Le fichier est trop volumineux (10 Mo)",
	"m059": "Équipement",
	"m060": "Champ",
	"m061": "L'importation est terminée. Au total, {{.a}} entrées ont été importées, dont {{.b}} ont été ajoutées ou modifiées.",
	"m062": "Importation échouée",
	"m063": "Fermer",
	"m064": "Même norme, comparaison non autorisée",
	"m065": "Erreur lors de la requête de la liste des contrôleurs",
	"m066": "L'extension du fichier n'est pas autorisée",
	"m067": "Le mot de passe est incorrect, veuillez le saisir à nouveau",
	"m068": "Mise à niveau réussie",
	"m069": "Êtes-vous sûr de vouloir réinitialiser le contrôleur aux paramètres d'usine ? ",
	"m070": "Le type d'équipement ne prend en charge que le 803",
	"m071": "Le système est en cours de traitement, veuillez patienter",
	"m072": "La tâche a été ajoutée avec succès, en cours de traitement",
	"m073": "L'importation remplacera les données existantes, êtes-vous sûr de vouloir procéder à l'importation ? ",
	"m074": "Erreur d'écriture du fichier",
	"m075": "Rechercher le nom de l'équipement/le numéro de l'équipement/l'adresse IP/les notes/MAC",
	"m076": "Tout en ligne",
	"m077": "Tout déconnecté",
	"m078": "Tous les appareils connectés avec succès",
	"m079": "Tous les appareils ont été déconnectés avec succès",
	"m080": "Tous les essais de connexion ont échoué",
	"m081": "Tous les déconnectages ont échoué",
	"m082": "Impossible de créer un tableau Excel",
	"m083": "Erreur de désérialisation de la courbe de soudage",
	"m084": "Erreur lors de la récupération des enregistrements d'alarme",
	"m085": "Écriture anormale des paramètres système 1",
	"m086": "Écriture anormale des paramètres système 2",
	"m087": "Erreur lors de l'écriture du paramètre système 3",
	"m088": "Non trouvé, veuillez d'abord ajouter la ligne de production correspondante",
	"m089": "Nombre total d'équipements",
	"m090": "Reconnexion",
	"m091": "Sauvegarde",
	"m092": "Paramètres de normalisation",
	"m093": "Sauvegarder les paramètres du système",
	"m094": "Vous n'avez sélectionné aucun appareil ! ",
	"m095": "Vous n'avez pas sélectionné les paramètres de sauvegarde ! ",
	"m096": "La sauvegarde par lots est en cours, veuillez patienter",
	"m097": "La sauvegarde n'existe pas ! ",
	"m098": "Erreur lors de l'archivage de la sauvegarde ! ",
	"m099": "La sauvegarde par lots est terminée, veuillez télécharger",
	"m100": "Échec de la création du fichier tar",
	"m101": "Échec de l'obtention du chemin",
	"m102": "Sauvegarde réussie",
	"m103": "Veuillez sélectionner le fichier à mettre à niveau",
	"m104": "mise à niveau de l'appareil",
	"m105": "une exception s'est produite pendant la mise à niveau",
	"m106": "les données du firmware sont vides et ne peuvent pas être mises à niveau",
	"m107": "périphérique{{.A}} impossible de se connecter, vérifiez que si vous rencontrez toujours des problèmes, essayez de redémarrer le périphérique",
	"m108": "fichier non mis à jour package, s'il vous plaît vérifier",
	"m109": "l'envoi du paquet de démarrage a échoué",
	"m110": "réception d'une exception de réponse de paquet de démarrage",
	"m111": "exception lors de l'envoi du paquet, emplacement du paquet:",
	"m112": "exception à la réception du paquet, emplacement du paquet:",
	"m113": "exception lors de l'envoi du paquet de fin",
	"m114": "exception lors de la réception du paquet de fin",
	"m115": "l'appareil est en cours de mise à niveau, veuillez patienter",
	"m116": "en cours de mise à niveau du périphérique",
	"m117": "mise à niveau réussie de l'appareil",
	"m118": "Échec de la mise à niveau du périphérique",
	"m119": "réessayer",
	"m120": "attendre pour commencer",
	"m121": "Aperçu général de la progression de la mise à niveau",
	"m122": "succès:",
	"m123": "échec",
	"m124": "en cours",
	"m125": "détails de la mise à niveau de l'appareil",
	"m126": "en raison de l'actualisation de la page, le fichier firmware est manquant et vous ne pouvez pas réessayer. ",
	"m127": "autre",
	"m128": "la mise à niveau a été annulée",
	"m129": "en cours d'annulation. … ",
	"m130": "après avoir annulé la mise à niveau, les appareils suivants cesseront la mise à niveau, confirmez - vous que vous souhaitez annuler? ",
	"m131": "appareil en ligne",
	"m132": "appareil hors ligne",
	"m133": "dispositif de reconnexion",
	"m134": "nom de périphérique / numéro de périphérique / IP",
	"m135": "aucun appareil associé trouvé pour le moment",
	"m136": "aucun périphérique n'est actuellement opérationnel",
	"m137": "id du périphérique",
	"m138": "version originale du logiciel du Contrôleur",
	"m139": "le téléchargement a échoué, aucune donnée pertinente n'a été trouvée",
	"m140": "résultat de l'Opération",
	"m141": "type de périphérique",
	"m142": "Veuillez sélectionner un type de périphérique",
	"m143": "ce type d'appareil n'est pas pris en charge par votre version de logiciel, veuillez contacter le fabricant.  le",
	"m144": "HRC-803 machine de soudage à fréquence intermédiaire",
	"m145": "HRC-802",
	"m146": "HRC-A50",
	"m147": "HRC-501",
	"m148": "HRC-650 moniteur de qualité de soudage",
	"m149": "HRC-670 moniteur de qualité riveté",
	"m150": "HRC-62 AC Welder",
	"m151": "Code d'activation actuel",
	"m152": "Sauvegarde des paramètres",
	"m153": "Restauration des paramètres",
	"m154": "Importation d'équipements",
	"m155": "Exportation des équipements",
	"m156": "L'appareil est en cours de sauvegarde des paramètres, veuillez patienter.",
	"m157": "La sauvegarde des paramètres a été annulée",
	"m158": "Impossible de créer le répertoire de sauvegarde, l'opération de sauvegarde a échoué.",
	"m159": "Une exception s'est produite lors de la sauvegarde, l'exportation des paramètres a échoué",
	"m160": "Impossible de lire les données de spécification, l'archivage des paramètres a échoué",
	"m161": "Impossible de créer un tableau Excel, l'archivage des paramètres a échoué",
	"m162": "Impossible de lire les paramètres système, sauvegarde des paramètres échouée",
	"m163": "L'équipement est hors ligne, l'archivage des paramètres a échoué",
	"m164": "Aperçu de l'avancement de la sauvegarde des paramètres",
	"m165": "Détails de sauvegarde des paramètres",
	"m166": "Sauvegarde des paramètres de l'équipement en cours",
	"m167": "Sauvegarde des paramètres réussie",
	"m168": "Échec du sauvegarde des paramètres",
	"m169": "Paramètres de spécification de sauvegarde",
	"m170": "Progrès de sauvegarde des paramètres de norme",
	"m171": "Progrès de la sauvegarde des paramètres du système",
	"m172": "Progrès de la sauvegarde des informations des points de soudure",
	"m173": "La tâche de mise à niveau a été relancée.",
	"m174": "La tâche de sauvegarde de reprise a été lancée",
	"m175": "La tâche de mise à niveau a été annulée et a été lancée",
	"m176": "La tâche de suppression de sauvegarde a été lancée",
	"m177": "Après l'annulation de la sauvegarde, les appareils ultérieurs cesseront de sauvegarder. Êtes-vous sûr de vouloir annuler ?",
	"m178": "Veuillez sélectionner un fichier compressé en tar",
	"m179": "Erreur lors du décompression du fichier. Veuillez vérifier l'intégrité du fichier.",
	"m180": "Restauration des paramètres terminée",
	"m181": "Une exception s'est produite lors du processus de restauration des paramètres.",
	"m182": "Aperçu du progrès de la restauration des paramètres",
	"m183": "Détails de la restauration des paramètres",
	"m184": "Restauration des paramètres de l'équipement en cours",
	"m185": "La restauration des paramètres a réussi",
	"m186": "Échec de la restauration des paramètres",
	"m187": "Régression du paramètre de conformité",
	"m188": "Progrès de la restauration des paramètres système",
	"m189": "Progress de restauration des informations sur les points de soudure",
	"m190": "Erreur d'importation des informations des points de soudure",
	"m191": "La sauvegarde a été annulée",
	"m192": "La restauration des paramètres a été annulée",
	"m193": "L'appareil est en cours de sauvegarde ou de restauration, impossible de télécharger.",
	"m194": "Après l'annulation de la restauration des paramètres, les restaurations ultérieures seront interrompues. Confirmez-vous que vous souhaitez annuler ?",
	"m195": "Impossible de trouver l'appareil correspondant dans le fichier compressé. Veuillez vérifier le fichier.",
	"m196": "La restauration des paramètres de redémarrage a été initiée",
	"m197": "L'équipement est en train d'exécuter d'autres tâches et ne peut pas être manipulé.",
	"m198": "Les paramètres de restauration sont :",
	"m199": "il est temporairement impossible d'ajouter ou de modifier un appareil car vos informations d'activation n'activent aucun type d'appareil",
	"m200": "cette opération n'est pas prise en charge pour le moment sur cet appareil.  le",
	"m201": "fichier de sauvegarde",
	"m202": "le fichier importé ne correspond pas au numéro ou au type de périphérique, le format de préfixe du nom de fichier doit être: numéro de périphérique + {{.a}}",
	"m203": "mot de passe de connexion",
	"m204": "Veuillez sélectionner un fichier",
	"m205": "impossible de récupérer après le nettoyage des données, confirmez - vous que vous souhaitez nettoyer? ",
	"m206": "nettoyer la sauvegarde",
	"m207": "nettoyage",
	"m208": "nettoyage réussi",
	"m209": "le nettoyage a échoué",
	"m210": "conflit d'adresse MAC du périphérique",
	"m211": "l'utilisateur {{.A}} sauvegarde les paramètres du périphérique {{.B}} :",
	"m212": "Le périphérique actuel est ouvert ; il ne peut pas être rouvert. ",
	"m213": "Adresse MAC",
	"m214": "Point d'accès",
	"m215": "Aide",
	"p001": "Nouvelle ligne de production",
	"p002": "Modifier la ligne de production",
	"p003": "La ligne de production est référencée, la suppression n'est pas autorisée",
	"p004": "Gestion de la ligne de production",
	"p005": "Nom de la ligne de production",
	"p006": "Remarque de la ligne de production",
	"p007": "Modification de la ligne de production réussie",
	"p008": "Ajout de la ligne de production réussi",
	"p009": "Nom de ligne de production en double",
	"p010": "Le nom de la ligne de production ne peut pas être vide et doit faire au moins 2 caractères",
	"p011": "Le classement doit être un entier positif et ne pas dépasser 5 chiffres",
	"p012": "Paramètre de pagination anormal",
	"p013": "Problème lors de la récupération des données de la ligne de production, veuillez réessayer plus tard",
	"p014": "Paramètre ID invalide, doit être un entier",
	"p015": "Soumission de données anormale",
	"p016": "Le nom de la ligne de production est en double, veuillez le modifier et soumettre à nouveau",
	"p017": "Erreur lors de l'ajout de la ligne de production, veuillez réessayer plus tard",
	"p018": "Mise à jour de la ligne de production anormale, veuillez réessayer plus tard",
	"p019": "Vérifiez si la ligne de production est occupée de manière anormale, veuillez réessayer plus tard",
	"p020": "Suppression de l'anomalie de la ligne de production, veuillez réessayer plus tard",
	"p021": "La ligne de production est en réparation, veuillez réessayer plus tard",
	"p022": "Suppression de la ligne de production réussie",
	"p023": "Rétablissement de la ligne de production réussi",
	"p024": "ligne/page",
	"p025": "Numéro de spécification pré-broyage",
	"p026": "Numéro de spécification post-broyage",
	"p027": "Aucune donnée disponible",
	"p028": "Enregistrer la courbe de référence",
	"p029": "Aucune donnée de courbe de résistance pour cet enregistrement",
	"p030": "Consulter les courbes de résistance avant et après le meulage",
	"p031": "Les longueurs des données de courbe avant et après broyage sont incohérentes ; sélection indisponible",
	"p032": "Cet enregistrement ne contient pas de données de courbe de résistance",
	"p033": "La longueur de courbe sélectionnée ne correspond pas à la longueur actuelle du graphique ; sélection indisponible",
	"p034": "Avant le réaffûtage",
	"p035": "Après le réaffûtage",
	"p036": "Veuillez d'abord sélectionner un enregistrement de courbe",
	"p037": "L'enregistrement sélectionné ne contient pas de données de courbe de résistance",
	"p038": "[Courbe de référence] Avant le réaffûtage",
	"p039": "[Courbe de référence] Après le réaffûtage",
	"p040": "Veuillez d'abord générer une courbe de référence",
	"p041": "Courbe de référence enregistrée avec succès",
	"p042": "Anomalie dans l'enregistrement de référence de la courbe",
	"p043": "Anomalie dans les données de la courbe",
	"p044": "La courbe dépasse la plage de fluctuation de la courbe de référence enregistrée, génération échouée",
	"p045": "La longueur de la courbe en temps réel ne correspond pas à la longueur de la courbe de référence",
	"p046": "La courbe en temps réel après rectification dépasse la plage de tolérance",
	"p047": "Paramètres de rectification",
	"p048": "Afficher les paramètres de rectification",
	"p049": "Gérer les paramètres de rectification",
	"p050": "Surveillance de la rectification",
	"p051": "Afficher la surveillance de la rectification",
	"p052": "Gérer la surveillance de la rectification",
	"p053": "Enregistrer la plage de fluctuation de la courbe de référence",
	"p054": "Surveiller la plage de fluctuation de la courbe de référence",
	"p055": "Type d'alarme",
	"p056": "Affichage",
	"p057": "[Courbe en temps réel] Avant le broyage",
	"p058": "[Courbe en temps réel] Après le broyage",
	"p059": "Courbe de résistance de référence actuelle",
	"p060": "Courbe de résistance de référence",
	"p061": "Aperçu de la courbe de résistance",
	"p062": "La valeur de résistance après rectification dépasse la valeur de résistance avant rectification",
	"p063": "La tolérance supérieure/inférieure de rejet automatique doit dépasser 0",
	"p064": "Tolérance supérieure/inférieure de rejet automatique",
	"p065": "Paramètres de surveillance de la courbe de résistance de soudage",
	"p066": "Activer le pré-filtrage",
	"p067": "Résistance moyenne après rectification supérieure à",
	"p068": "Classée comme normale",
	"p069": "Le système a automatiquement rejeté les courbes dépassant la plage de tolérance",
	"p070": "Tolérance supérieure sur la courbe après rectification",
	"p071": "Tolérance inférieure sur la courbe après rectification",
	"p072": "Veuillez saisir les numéros de spécification avant et après le réaffûtage",
	"p073": "Pré-réaffûtage - La résistance post-réaffûtage doit être supérieure à 0",
	"p074": "La tolérance supérieure/inférieure de la courbe post-réaffûtage doit être supérieure à 0",
	"p075": "Le préfiltre dépasse la plage normale",
	"p076": "Version du logiciel",
	"p077": "Cette fonctionnalité n'est pas prise en charge par cette version",
	"p078": "La sélection d'étalonnage actuelle est définie sur la valeur par défaut du système et ne peut pas être étalonnée. ",
	"p079": "Étape",
	"p080": "Limite inférieure",
	"p081": "Limite supérieure",
	"p082": "Le numéro de spécification de fin ne peut pas être inférieur au numéro de spécification de début",
	"p083": "Les plages de numéros de spécification ne correspondent pas, opération impossible",
	"p084": "Synchronisation des spécifications",
	"p085": "Différences entre les éléments",
	"p086": "Tout est identique",
	"p087": "L'appareil source et l'appareil cible sont identiques, la synchronisation est impossible",
	"p088": "Les paramètres de spécification de [ ] ont été synchronisés vers l'appareil cible :",
	"p089": "Synchronisation des paramètres",
	"u001": "Gestion des utilisateurs",
	"u002": "Nouvel utilisateur",
	"u003": "Nom",
	"u004": "Rôle",
	"u005": "mot de passe",
	"u006": "Modifier l'utilisateur",
	"u007": "Inspecteur",
	"u008": "Opérateur",
	"u009": "Administrateur",
	"u010": "Non activé",
	"u011": "normal",
	"u012": "gelé",
	"u013": "Le nom du compte doit comporter au moins trois caractères",
	"u014": "Le nom doit comporter au moins trois caractères",
	"u015": "Le mot de passe doit comporter au moins trois caractères",
	"u016": "Veuillez sélectionner un rôle",
	"u017": "Veuillez sélectionner l'état",
	"u018": "Modification de l'utilisateur réussie",
	"u019": "Ajout de l'utilisateur réussi",
	"u020": "Une erreur s'est produite lors de la récupération des données utilisateur, veuillez réessayer plus tard.",
	"u021": "Suppression de l'utilisateur réussie",
	"u022": "Restauration de l'utilisateur réussie",
	"u023": "Le nom de compte est déjà utilisé, veuillez le modifier",
	"u024": "Erreur lors de l'ajout de l'utilisateur, veuillez réessayer plus tard",
	"u025": "Erreur lors de l'édition de l'utilisateur, veuillez réessayer plus tard",
	"u026": "Erreur lors de la suppression de l'utilisateur, veuillez réessayer plus tard",
	"u027": "Récupération de l'anomalie de l'utilisateur, veuillez réessayer plus tard",
	"u028": "ID de l'opérateur",
	"u029": "Gestion des rôles",
	"u030": "Créer un nouveau rôle",
	"u031": "Erreur lors de la récupération des données du personnage, veuillez réessayer plus tard",
	"u032": "Le nom du personnage est en double, veuillez le modifier",
	"u033": "Erreur lors de l'ajout du rôle, veuillez réessayer plus tard",
	"u034": "Erreur lors de l'édition du personnage, veuillez réessayer plus tard",
	"u035": "Erreur lors de la suppression du rôle, veuillez réessayer plus tard",
	"u036": "La restauration du personnage a échoué. Veuillez réessayer plus tard.",
	"u037": "Ajout du rôle réussi",
	"u038": "Édition du rôle réussie",
	"u039": "Suppression du rôle réussie",
	"u040": "Récupération du personnage réussie",
	"u041": "Nom du rôle",
	"u042": "Modifier le rôle",
	"u043": "Le nom du rôle ne peut pas être vide et doit faire au moins 2 caractères",
	"u044": "Permissions",
	"u045": "Ligne de production",
	"u046": "Voir la ligne de production",
	"u047": "Paramètres d'autorisation",
	"u048": "Équipement",
	"u049": "Voir les équipements",
	"u050": "L'équipement est connecté",
	"u051": "utilisateur",
	"u052": "Utilisateur consulte",
	"u053": "Voir la bibliothèque de normes",
	"u054": "Gestion normalisée des bibliothèques",
	"u055": "Consultation des enregistrements du système",
	"u056": "Gestion des enregistrements système",
	"u057": "Vérification de l'initialisation du système",
	"u058": "Gestion de l'initialisation du système",
	"u059": "Voir la surveillance en temps réel",
	"u060": "Surveillance opérationnelle en temps réel",
	"u061": "Voir la surveillance en temps réel",
	"u062": "Surveillance en temps réel des opérations",
	"u063": "Voir les paramètres de norme",
	"u064": "Opération des paramètres standardisés",
	"u065": "Voir la gestion de la production",
	"u066": "Gestion de la production opérationnelle",
	"u067": "Voir les paramètres du système",
	"u068": "Opération des paramètres du système",
	"u069": "Voir les enregistrements de soudage",
	"u070": "Enregistrement des opérations de soudage",
	"u071": "Consultation des enregistrements d'alarme",
	"u072": "Opérations sur les enregistrements d'alarme",
	"u073": "Voir les enregistrements de modification",
	"u074": "Opération de modification des enregistrements",
	"u075": "Voir la gestion des points de soudure",
	"u076": "Gestion des opérations de soudure",
	"u077": "Voir le rôle",
	"u078": "La configuration des autorisations a réussi",
	"u079": "confirmer le mot de passe",
	"u080": "deux entrées de mot de passe incohérentes, veuillez les saisir à nouveau! ",
	"u081": "les informations d'inscription ne sont pas autorisées à les obtenir, veuillez les autoriser en premier. ",
	"u082": "les informations d'inscription sont manquantes, veuillez les activer en premier. ",
	"u083": "informations d'inscription anormales, veuillez vous réinscrire. ",
	"u084": "la version actuelle est une version d'essai, pour utiliser le logiciel, demandez un code d'activation. ",
	"u085": "activé",
	"u086": "activation du produit",
	"u087": "numéro de série du produit",
	"u088": "Veuillez envoyer le numéro de série du produit ci - dessous au marchand pour obtenir le Code d'activation. ",
	"u089": "Entrez le Code d'activation",
	"u090": "en cas de problème, veuillez contacter le support technique. ",
	"u091": "copie réussie. ",
	"u092": "la réplication a échoué. ",
	"u093": "activer le produit",
	"u094": "activer la vue",
	"u095": "opération d'excitation",
	"u096": "anomalie de niveau utilisateur",
	"u097": "la génération du Code d'activation a échoué",
	"u098": "Code d'activation incorrect",
	"u099": "Veuillez entrer le Code d'activation",
	"u100": "le numéro de série du produit est manquant",
	"u102": "le Code d'activation n'est pas valide! ",
	"u103": "l'écriture des informations d'activation a échoué, veuillez patienter et réessayer",
	"u104": "activation réussie, nous ouvrirons les autorisations en fonction de vos informations de code d'activation, en cas de doute, veuillez contacter le fabricant.  le",
	"u105": "Modifier le mot de passe",
	"u106": "Ancien mot de passe",
	"u107": "Nouveau mot de passe",
	"u108": "Veuillez saisir votre ancien mot de passe",
	"u109": "Ancien mot de passe incorrect",
	"u110": "Veuillez saisir votre nouveau mot de passe",
	"u111": "Mot de passe modifié avec succès",
	"u112": "Échec de la modification du mot de passe",
	"u113": "Afficher les colonnes",
	"u114": "Sélectionner les colonnes à afficher",
	"u115": "Veuillez sélectionner au moins une colonne à afficher",
	"l001": "console",
	"l002": "En ligne",
	"l003": "Tous en ligne",
	"l004": "Tout hors ligne",
	"l005": "Alerte",
	"l006": "Désactivation réussie",
	"l007": "Connexion réussie",
	"l008": "Échec du débranchement",
	"l009": "Échec de la connexion",
	"l010": "Tout replier",
	"l011": "Développer tout",
	"b001": "Gestion de base de données",
	"b002": "Bibliothèque de normes",
	"b003": "Copie des paramètres du système",
	"b004": "Comparaison des paramètres",
	"b005": "Paramètre de limitation de courant",
	"b006": "Numéro de norme",
	"b007": "Nom normalisé",
	"b008": "Soudure 1 minimum",
	"b009": "Soudage 1 max",
	"b010": "Soudure 2 minimum",
	"b011": "Soudure 2 maximum",
	"b012": "Soudure 3 minimale",
	"b013": "Soudure 3 maximale",
	"b014": "Mode de puissance",
	"b015": "Mélange",
	"b016": "Courant constant",
	"b017": "rapport cyclique",
	"b018": "Précharge",
	"b019": "poursuite de la pression",
	"b020": "Pré-soudage",
	"b021": "refroidissement",
	"b022": "Lent ascension",
	"b023": "soudure 1",
	"b024": "Froid 1",
	"b025": "Soudure 2",
	"b026": "Froid 2",
	"b027": "Soudure 3",
	"b028": "Descente lente",
	"b029": "refroidissement",
	"b030": "Soudage postérieur",
	"b031": "Maintenir",
	"b032": "Repos",
	"b033": "Copier",
	"b034": "Réinitialiser ce groupe",
	"b035": "Télécharger les normes de ce groupe",
	"b036": "Spécifications pour le téléchargement par lots",
	"b037": "Nombre d'impulsions de soudage 2",
	"b038": "Aucune donnée de configuration",
	"b039": "Erreur lors de l'obtention de la valeur de norme maximale",
	"b040": "Norme",
	"b041": "Ajout de l'anomalie de norme, veuillez réessayer plus tard",
	"b042": "Ajout de la norme réussi",
	"b043": "Erreur lors de la modification des normes, veuillez réessayer plus tard",
	"b044": "La modification de la norme a réussi",
	"b045": "Suppression de l'anomalie de norme, veuillez réessayer plus tard",
	"b046": "La suppression de la norme a réussi",
	"b047": "Le numéro de norme est en double, veuillez le modifier avant de soumettre",
	"b048": "Erreur lors de la récupération du numéro de norme, veuillez réessayer plus tard",
	"b049": "Le nom de la norme ne peut pas être vide",
	"b050": "Erreur lors de la copie de la norme, veuillez réessayer plus tard",
	"b051": "La copie de la norme a réussi",
	"b052": "Veuillez sélectionner la norme à supprimer",
	"b053": "Veuillez sélectionner la norme à réinitialiser",
	"b054": "Veuillez sélectionner la norme à copier",
	"b055": "Les données supprimées ne peuvent pas être récupérées, êtes-vous sûr de vouloir les supprimer ? ",
	"b056": "Sélectionner tout",
	"b057": "Équipement source",
	"b058": "Dispositif cible",
	"b059": "Télécharger tous les paramètres du système",
	"b060": "Comparer",
	"b061": "Mode de comparaison",
	"b062": "Contrôleur",
	"b063": "Requête de données anormales dans la base de normes",
	"b064": "Opération anormale",
	"b065": "Paramètre",
	"b066": "Courant minimal de soudage 1",
	"b067": "Courant maximal de soudage 1",
	"b068": "Courant minimum de soudure 2",
	"b069": "Courant maximal de soudure 2",
	"b070": "Courant minimum de soudage 3",
	"b071": "Courant maximal de soudage 3",
	"b072": "Temps de précharge",
	"b073": "Pression de précharge",
	"b074": "Temps de suivi de la pression",
	"b075": "Pression de suivi",
	"b076": "Sélection de contrôle de pré-soudage",
	"b077": "Courant de pré-soudage",
	"b078": "Temps de pré-soudage",
	"b079": "[Réserver] Pression pré-soudage [KN(0-10000) ou %(0-100)]",
	"b080": "Temps de refroidissement 0",
	"b081": "[Réservé] Pression de refroidissement 0 (KN ou %)",
	"b082": "Temps de montée lente",
	"b083": "Sélection de contrôle de soudure 1",
	"b084": "Courant de soudage 1",
	"b085": "Temps de soudure 1",
	"b086": "Fonction UIP sélectionnée 0~1",
	"b087": "Temps de refroidissement 1",
	"b088": "[Réserver] Pression de soudage 1 [KN(0-10000) ou %(0-100)]",
	"b089": "Sélection de contrôle de soudage 2",
	"b090": "Courant de soudage 2",
	"b091": "Temps de soudage 2",
	"b092": "Pression de soudage 2",
	"b093": "Temps de refroidissement 2",
	"b094": "Valeur de référence UIP %",
	"b095": "Nombre d'impulsions de soudage 2",
	"b096": "Sélection de contrôle de soudure 3",
	"b097": "Courant de soudage 3",
	"b098": "Temps de soudage 3",
	"b099": "Bande de tolérance supérieure sur UIP %",
	"b100": "Temps de descente lente",
	"b101": "Temps de refroidissement 3",
	"b102": "Bande de tolérance conditionnelle sur UIP",
	"b103": "Sélection du contrôle de soudage ultérieur",
	"b104": "Courant de soudage postérieur",
	"b105": "Temps de soudage ultérieur",
	"b106": "Bande de tolérance conditionnelle sous UIP",
	"b107": "Durée de conservation",
	"b108": "Bandes de tolérance inférieures de l'UIP",
	"b109": "Temps d'arrêt",
	"b110": "Pression de repos",
	"b111": "Sélection du contrôle de puissance (0-2) 0: Courant constant 1: Rapport cyclique 2: Mixte",
	"b112": "Seuil de résistance de reconnaissance des projections",
	"b113": "Contrôleur 1",
	"b114": "Contrôleur 2",
	"b115": "Bibliothèque de normes 1",
	"b116": "Bibliothèque standard 2",
	"b117": "Télécharger les normes de ce groupe",
	"b118": "Téléchargement par lots selon les normes",
	"b119": "Sélectionnez le numéro de l'appareil : ",
	"b120": "Téléchargement sur le microcontrôleur n° :",
	"b121": "Groupe",
	"b122": "sous-ordinateur",
	"b123": "De",
	"b124": "à",
	"b125": "Téléchargement réussi",
	"b126": "Erreur lors de l'obtention du type d'équipement",
	"b127": "Le numéro de spécification de l'appareil cible dépasse la plage (0-{{.a}})",
	"b128": "Le numéro de norme  {{.a}}  n'existe pas",
	"b129": "Échec du téléchargement",
	"b130": "Erreur de sélection de portée",
	"b131": "L'intervalle de téléchargement est incohérent ({{.a}}~{{.b}})",
	"b132": "L'utilisateur  {{.a}}  a téléchargé la norme  {{.c}}  pour l'appareil ayant l'ID  {{.b}} ",
	"b133": "L'utilisateur  {{.a}}  a téléchargé en lot les numéros de spécification pour l'appareil d'ID  {{.b}} , du  {{.c}}  au  {{.d}}  jusqu'au  {{.e}}  au  {{.f}} ",
	"b134": "Veuillez sélectionner l'appareil source et l'appareil cible",
	"b135": "Confirmer l'opération",
	"b136": "Confirmez-vous que vous souhaitez déplacer l'appareil 【",
	"b137": "Confirmez-vous que vous souhaitez transférer l'appareil [",
	"b138": "Synchroniser les paramètres du système du 】 vers l'appareil cible ? ",
	"b139": "Les données soumises ne sont pas un numéro de contrôleur valide",
	"b140": "L'utilisateur  {{.a}}  a copié les paramètres du système de norme de charge de la machine Id :  {{.b}}  vers :  {{.c}} ",
	"b141": "Numéro de norme identique, impossible de comparer",
	"b142": "Numéro de norme hors de la plage (0-959)",
	"b143": "Numéro de norme hors de la plage (0-63)",
	"b144": "Le contrôleur n'a pas été trouvé",
	"b145": "[Réserve] Pression de soudage 1 [KN(0-10000) ou %(0-100)]",
	"b146": "[Réserver] Pression de refroidissement 2 [KN(0-10000) ou %(0-100)]",
	"b147": "[Conserver] Pression de refroidissement 3 [KN(0-10000) ou %(0-100)]",
	"b148": "[Conserver] Pression post-soudage [KN(0-10000) ou %(0-100)]",
	"b149": "[Réserve] Maintenir la pression [KN(0-10000) ou %(0-100)]",
	"b150": "Même norme, comparaison non autorisée",
	"b151": "{{.a}} Erreur de saisie",
	"b152": "Erreur de validation de l'entrée",
	"b153": "Synchronisation depuis l'appareil vers la base de données hors ligne",
	"b154": "Synchroniser depuis la bibliothèque hors ligne vers l'appareil",
	"b155": "Le",
	"b156": "Synchronisation",
	"b157": "Erreur de sélection de plage",
	"b158": "L'utilisateur  {{.a}}  a synchronisé l'appareil ID  {{.b}}  depuis l'appareil  {{.c}}  vers la norme de base de données hors ligne  {{.d}} ",
	"b159": "Synchronisation réussie",
	"b160": "Échec de la synchronisation",
	"b161": "Utilisateur {{.a}} a enregistré les spécifications de la bibliothèque hors ligne pour l'appareil ID {{.b}} : {{.c}}",
	"b162": "Sauvegarde réussie",
	"b163": "Échec de l'enregistrement",
	"b164": "L'utilisateur {{.a}} a synchronisé le stockage hors ligne de l'appareil ID {{.b}} vers la norme {{.c}}.",
	"b165": "Exporter les paramètres de norme",
	"b166": "Mode de contrôle de pré-soudage",
	"b167": "Mode de contrôle de la soudure 1",
	"b168": "Mode de contrôle de soudure 2",
	"b169": "Mode de contrôle de soudage 3",
	"b170": "Mode de contrôle de soudage postérieur",
	"b171": "L'importation remplacera les données existantes, êtes-vous sûr de vouloir importer ? ",
	"b172": "Ce fichier ne peut pas être importé sur cet appareil",
	"b173": "Utilisateur {{.a}} a importé la norme pour l'appareil ID {{.b}} : {{.c}}",
	"b174": "Utilisateur {{.a}} a importé l'appareil ID {{.b}} dans la norme de la bibliothèque hors ligne: {{.c}}",
	"b175": "Importation terminée, {{.a}} éléments importés au total",
	"b176": "Détails",
	"b177": "Veuillez sélectionner l'enregistrement à supprimer",
	"b178": "Échec de la suppression du enregistrement",
	"b179": "Suppression de l'enregistrement réussie",
	"b180": "Êtes-vous sûr de vouloir supprimer les enregistrements sélectionnés ? ",
	"b181": "Confirmer",
	"b182": "Annuler",
	"b183": "L'obtention des données d'enregistrement de soudage présente une anomalie, veuillez réessayer plus tard",
	"b184": "Numéro de norme actuellement utilisé",
	"b185": "Phase de travail actuelle",
	"b186": "Temps de fonctionnement à l'étape actuelle",
	"b187": "L'enregistrement n'existe pas",
	"b188": "Échec de la recherche, aucune courbe de soudage correspondante n'a été trouvée",
	"b189": "Une erreur s'est produite lors de la récupération des données d'alerte, veuillez réessayer plus tard",
	"b190": "Erreur lors de la récupération des données de modifications, veuillez réessayer plus tard",
	"b191": "Détails de la norme",
	"b192": "Veuillez cliquer sur le bouton 'Télécharger' pour activer la fonction 'Réinitialisation' !",
	"b193": "La pression dépasse la plage autorisée",
	"b194": "L'épaisseur de la plaque dépasse la plage autorisée",
	"b195": "ligne",
	"b196": "Existe déjà",
	"b197": "D'autres tâches en cours, impossible de traiter pour le moment",
	"b198": "Gestion des points de soudure Importation réussie",
	"b199": "Gestion des points de soudure Échec de l'opération d'importation",
	"b200": "Gestion des points de soudure Vérification de l'opération réussie",
	"b201": "Gestion des points de soudure Échec de l'opération de vérification",
	"b202": "Gestion des points de soudure L'opération de nettoyage a réussi",
	"b203": "Gestion des points de soudure Échec de l'opération de nettoyage",
	"b204": "La pression dépasse la plage autorisée (0-65535)",
	"b205": "Épaisseur de la plaque hors de la plage (0-655.35)",
	"b206": "Veuillez sélectionner la norme ! Si aucune norme n'existe, veuillez en ajouter une.",
	"b207": "Gestion des points de soudure Importation réussie",
	"b208": "Échec de l'opération d'importation de la gestion des points de soudure",
	"b209": "Échec de la suppression des données de soudure locale",
	"b210": "Impossible de créer le point de soudure",
	"b211": "Paramètre 'start' manquant ! ",
	"b212": "Le paramètre 'start' ne peut être qu'un entier !",
	"b213": "Paramètre 'end' manquant ! ",
	"b214": "Le paramètre 'end' ne peut être qu'un entier ! ",
	"b215": "Valeur de référence de la largeur d'impulsion",
	"b216": "Valeur d'accumulation de la largeur d'impulsion",
	"b217": "Valeur du comptage de largeur d'impulsion",
	"b218": "Gestion des points de soudure Échec du téléchargement de l'opération",
	"b219": "La valeur du compteur de largeur d'impulsion ne peut être réglée que sur 0",
	"b220": "La valeur du compteur de largeur d'impulsion ne peut être réglée que sur 0. Une fois réglée sur 0, la valeur de référence de la largeur d'impulsion et la valeur cumulée de la largeur d'impulsion sont également mises à 0",
	"r001": "État de l'équipement",
	"r002": "Travail",
	"r003": "Affûtage",
	"r004": "Soudage",
	"r005": "Vérifier",
	"r006": "Essai de pression",
	"r007": "Essai de soudure",
	"r008": "Alerte",
	"r009": "Voir les enregistrements d'alarme",
	"r010": "État IO",
	"r011": "Onde de soudage",
	"r012": "Informations sur le contrôleur",
	"r013": "Données en temps réel",
	"r014": "Comptage des points de soudure par pièce",
	"r015": "Production par équipe",
	"r016": "Nombre total de productions",
	"r017": "Nombre total de points de soudure",
	"r018": "Nombre d'augmentations déjà effectuées",
	"r019": "Nombre de pièces usinées",
	"r020": "Tension de la barre omnibus",
	"r021": "Valeur actuelle du compteur de projection selon la norme",
	"r022": "Total de la valeur du compteur de projection",
	"r023": "Version matérielle du contrôleur",
	"r024": "Version du logiciel système",
	"r025": "Version du logiciel CPLD",
	"r026": "Version BOOT",
	"r027": "Électrode",
	"r028": "Entrée",
	"r029": "Sortie",
	"r030": "Signal de démarrage 1",
	"r031": "Signal de démarrage 2",
	"r032": "Sélection du programme 1",
	"r033": "Sélection du programme 2",
	"r034": "Sélection du programme 4",
	"r035": "Sélection du programme 8",
	"r036": "Sélection de programme 16",
	"r037": "Sélection de programme 32",
	"r038": "Inspection / Soudage",
	"r039": "Réinitialisation de l'alarme",
	"r040": "Travail / Affûtage",
	"r041": "Arrêt d'urgence",
	"r042": "Interrupteur de température du transformateur",
	"r043": "Interrupteur de température de l'onduleur",
	"r044": "Interrupteur d'eau",
	"r045": "Interrupteur de pression atmosphérique",
	"r046": "Soudage autorisé",
	"r047": "Réserver",
	"r048": "Réinitialisation du comptage",
	"r049": "Programme 64",
	"r050": "Programme 128",
	"r051": "Programme 256",
	"r052": "Programme 512",
	"r053": "Confirmation de l'affûtage de l'électrode",
	"r054": "Confirmation du remplacement de l'électrode",
	"r055": "Réserver28",
	"r056": "Réserver29",
	"r057": "Réserver30",
	"r058": "Réserver31",
	"r059": "Machine prête",
	"r060": "Soupape 1",
	"r061": "Soupape d'admission 2",
	"r062": "Soupape d'admission 3",
	"r063": "Soupape d'admission 4",
	"r064": "Soudage terminé",
	"r065": "Déclenchement IGBT",
	"r066": "Demande de soudage",
	"r067": "Sortie du moteur",
	"r068": "Sortie d'alarme",
	"r069": "Affûtage des électrodes",
	"r070": "Remplacement des électrodes",
	"r071": "Fraisage de la valve",
	"r072": "Action terminée",
	"r073": "Réserver20",
	"r074": "Réserver21",
	"r075": "Réserver 22",
	"r076": "Réserver23",
	"r077": "Réserver24",
	"r078": "Réserver 25",
	"r079": "Réserver26",
	"r080": "Réserver 27",
	"r081": "Courant",
	"r082": "Tension",
	"r083": "résistance",
	"r084": "pression",
	"r085": "Paramètres de collecte",
	"r086": "Paramètres",
	"r087": "Collecte de la courbe de courant",
	"r088": "Collecter la courbe de résistance",
	"r089": "Collecte de la courbe de tension",
	"r090": "Collecte de la courbe de pression",
	"r091": "Paramètres enregistrés avec succès",
	"r092": "Échec de la mise à jour de la courbe de collecte",
	"r093": "La mise à jour de la courbe de collecte a réussi",
	"r094": "Type d'opération inconnu",
	"r095": "Numéro d'appareil invalide",
	"r096": "L'appareil est hors ligne, aucune opération n'est autorisée",
	"r097": "Opération réussie",
	"r098": "Échec de l'opération",
	"r099": "{{.a}} Opération inconnue",
	"r100": "Paramètres d'affichage non trouvés",
	"r101": "Données de soudage",
	"r102": "Données statistiques",
	"r103": "Compter",
	"r104": "Voir",
	"r105": "Numéro d'enregistrement de soudage",
	"r106": "Version du logiciel du contrôleur",
	"r107": "Gestion des points de soudure L'opération de rafraîchissement a réussi",
	"r108": "Gestion des points de soudure Échec de l'opération de rafraîchissement",
	"r109": "L'importation sera fusionnée avec les données existantes. Voulez-vous vraiment importer ? ",
	"r110": "Requête d'informations anormales sur les points de soudure",
	"r111": "Cette opération n'est pas autorisée en mode essai de soudage ou de pression",
	"r112": "Cette opération n'est pas autorisée en mode de meulage",
	"r113": "Développement de fonctionnalité en cours",
	"r114": "support graphique plage de sélection des cases pour zoomer, double clic de souris pour restaurer la taille par défaut",
	"r115": "Impossible de lire le fichier système",
	"r116": "Confirmer le nouveau joint de soudure",
	"r117": "Sélectionner le nouveau joint de soudure",
	"r118": "Affichage des points d'éclaboussure",
	"r119": "Surveillance des tendances",
	"r120": "Afficher les paramètres",
	"r121": "Tendances",
	"r122": "Courant de soudage 1 (kA)",
	"r123": "Courant de soudage 2 (kA)",
	"r124": "Courant de soudage 3 (kA)",
	"r125": "Nombre maximal",
	"r126": "Anomalie dans les paramètres de spécification saisis",
	"r127": "Courant de pré-soudage (kA)",
	"r128": "Courant de post-soudage (kA)",
	"r129": "UIP",
	"r130": "Pour plusieurs numéros de spécification, veuillez utiliser la virgule comme séparateur",
	"r131": "Veuillez saisir le numéro de spécification",
	"r132": "Le numéro de spécification doit être un nombre entier",
	"r133": "Le numéro de mappage des points de soudure doit être un nombre entier",
	"r134": "Veuillez saisir une valeur de quantité limite valide",
	"r135": "La quantité limite ne doit pas dépasser 1000",
	"r136": "Courbe de soudage",
	"r137": "En temps réel",
	"r138": "Historique",
	"r139": "Les données en temps réel ne permettent de consulter que les enregistrements de soudage des sept derniers jours",
	"r140": "Le nombre de points de soudure enregistrés ne doit pas dépasser 10000",
	"r141": "Courbe de référence de résistance",
	"r142": "Référence d'énergie minimale",
	"r143": "Référence d'énergie maximale",
	"r144": "Référence d'énergie",
	"r145": "Modification de la courbe UIR",
	"s001": "Journal du système",
	"s002": "Numéro",
	"s003": "Opérateur",
	"s004": "Numéro de l'objet",
	"s005": "Résumé",
	"s006": "Temps d'opération",
	"s007": "État de la phase d'échelonnage",
	"s008": "Sélection de la phase",
	"s009": "Le contrôleur d'activation est prêt, commence à fonctionner normalement",
	"s010": "Activation du contrôleur de soudage",
	"s011": "État des ports d'E/S de l'ordinateur hôte",
	"s012": "Commande de suppression d'erreur",
	"s013": "Valeur de réglage de la sortie PWM du courant",
	"s014": "Valeur de réglage de la pression de l'électrode",
	"s015": "Valeur affichée de la tension du bus",
	"s016": "Valeur d'affichage du courant primaire",
	"s017": "Valeur d'affichage du courant secondaire",
	"s018": "Valeur affichée de la pression de l'électrode",
	"s019": "Commande de réinitialisation du compteur de soudage",
	"s020": "Mot de statut de l'entrée Profibus 00",
	"s021": "Mot de statut de l'entrée Profibus 01",
	"s022": "Mot de statut de sortie Profibus 00",
	"s023": "Mot de statut de sortie Profibus 01",
	"s024": "Mot de statut d'entrée DeviceNet 00",
	"s025": "Mot de statut d'entrée Devicenet 01",
	"s026": "Mot de statut de sortie Devicenet 00",
	"s027": "Mot de statut de sortie Devicenet 00",
	"s028": "Cliquez ou faites glisser le fichier ici pour le télécharger",
	"s029": "Importation terminée",
	"s030": "Rafraîchir",
	"s031": "Vérification",
	"s032": "Effacer",
	"s033": "Nouveau point de soudure",
	"s034": "Modifier le point de soudure",
	"s035": "Réservé",
	"s036": "Pointeur d'adresse de remplissage du registre d'alarmes historiques",
	"s037": "Mot d'état d'alarme (0~31)",
	"s038": "Pression de pré-soudage",
	"s039": "Pression de refroidissement 0",
	"s040": "Pression de montée lente",
	"s041": "Pression de soudage 1",
	"s042": "Pression de refroidissement 1",
	"s043": "Pression de refroidissement 2",
	"s044": "Pression de soudage 3",
	"s045": "Réduction progressive de la pression",
	"s046": "Pression de refroidissement 3",
	"s047": "Pression post-soudage",
	"s048": "Maintenir la pression",
	"s049": "Le modèle de voiture en cours de production par la pince à souder 1, le champ 00 (valeur stockée en ASCII)",
	"s050": "Le modèle de véhicule en cours de production par la pince à souder 1, champ 01 (la valeur stockée est en ASCII)",
	"s051": "Le modèle de véhicule en cours de production par la pince de soudage 1, champ 02 (valeur stockée en code ASCII)",
	"s052": "Le modèle de véhicule en cours de production par la pince de soudage 1, champ 03 (la valeur stockée est une valeur ASCII)",
	"s053": "Le modèle de véhicule en cours de production par la pince de soudage 2, le champ 00 (valeur stockée sous forme de code ASCII)",
	"s054": "Le modèle de véhicule en cours de production avec la pince à souder 2, champ 01 (la valeur stockée est une valeur ASCII)",
	"s055": "Le modèle de véhicule en cours de production par la pince de soudage 2, champ 02 (la valeur stockée est un code ASCII)",
	"s056": "Le modèle de véhicule en cours de production par la pince à souder 2, champ 03 (valeur stockée sous forme de code ASCII)",
	"s057": "Mode de pression de l'électrode",
	"s058": "Fonction de démarrage 2 sélectionnée ?",
	"s059": "Fonction de confirmation des points de soudure sélectionnée",
	"s060": "Nombre de soudures de réparation",
	"s061": "Pression d'essai",
	"s062": "Version logicielle du contrôleur CPLD",
	"s063": "Sélection de l'interface de communication",
	"s064": "Adresse de communication",
	"s065": "Fonctionnalité réseau",
	"s066": "IP0",
	"s067": "IP1",
	"s068": "Numéro de série de l'appareil",
	"s069": "DeviceNet BaudRate",
	"s070": "Tension nominale",
	"s071": "Nombre d'onduleurs",
	"s072": "Sélection des fonctions autorisées pour le soudage",
	"s073": "Rapport de spires du transformateur",
	"s074": "Rendement du transformateur",
	"s075": "Mode de contrôle à courant constant",
	"s076": "Seuil de courant primaire",
	"s077": "Contrôle de réinitialisation de l'alarme de protection IGBT",
	"s078": "Sélection de la fonction d'arrêt d'urgence HMI",
	"s079": "Fonction de priorité du groupe de programmes sélectionnée",
	"s080": "Sélection des fonctions de la valve proportionnelle",
	"s081": "Fonction de sélection du mode hors ligne du contrôleur en cas de déconnexion de l'HMI",
	"s082": "Mode de déclenchement de travail à grande ouverture",
	"s083": "Fonction de confirmation de l'usinage des électrodes",
	"s084": "Lors du soudage suspendu, le déclenchement retardé de l'écartement des pinces de soudage",
	"s085": "Coefficient de proportionnalité entre la valeur d'échantillonnage du courant de la bobine de Rogowski du pince-soudure 1 et la valeur réelle du courant",
	"s086": "Coefficient de proportionnalité entre la valeur d'échantillonnage du courant de la bobine de Rogowski du pince-soudure 2 et la valeur réelle du courant",
	"s087": "Coefficient de proportionnalité entre la valeur échantillonnée du courant de la bobine du pince-soudure 1CT et la valeur réelle du courant",
	"s088": "Coefficient de proportionnalité entre la valeur d'échantillonnage du courant de la bobine du pince-soudure 2CT et la valeur réelle du courant",
	"s089": "Le système pince à souder 1 prend en charge le courant maximal réel",
	"s090": "Le système de pince de soudage 2 prend en charge le courant maximal réel",
	"s091": "Angle de facteur de puissance actuel de la pince de soudage du système 1",
	"s092": "Angle du facteur de puissance actuel du pince-soudure système 2",
	"s093": "L'angle de contrôle de déclenchement de soudage actuel du système",
	"s094": "Pour l'état d'ouverture du bras d'électrode après la coupure de courant du contrôleur de soudage suspendu",
	"s095": "Mode de sortie du signal de fin de soudage et du signal de fin d'action",
	"s096": "Coefficient d'affichage de la tension du bus, ce paramètre n'a plus besoin d'être configuré maintenant",
	"s097": "Valeur de réglage de sortie PWM du courant primaire minimum de la pince de soudage 1",
	"s098": "Valeur de réglage de la sortie PWM du courant primaire de la première section de la pince à souder 1",
	"s099": "Valeur de réglage de la sortie PWM du courant primaire de la deuxième étape du pince-soudure 1",
	"s100": "Valeur de réglage de la sortie PWM du courant primaire en trois segments pour la pince à souder 1",
	"s101": "Valeur de réglage de sortie PWM du courant primaire en quatre segments pour la pince à souder 1",
	"s102": "Valeur de réglage de la sortie PWM du courant primaire en cinq segments pour la pince à souder 1",
	"s103": "Valeur de réglage de sortie PWM du courant primaire en six segments pour la pince à souder 1",
	"s104": "Valeur de réglage de sortie PWM du courant primaire maximal du pince-soudure 1",
	"s105": "Valeur d'échantillonnage du courant primaire minimum du pinceau de soudage 1",
	"s106": "Valeur d'échantillonnage du courant primaire de la première section de la pince à souder 1",
	"s107": "Valeur d'échantillonnage du courant primaire de la deuxième étape du pinceau de soudage 1",
	"s108": "Valeur d'échantillonnage du courant primaire en trois étapes de la pince de soudage 1",
	"s109": "Valeur d'échantillonnage du courant primaire en quatre segments du pince-soudure 1",
	"s110": "Valeur d'échantillonnage du courant primaire en cinq segments du pinceau de soudage 1",
	"s111": "Valeur d'échantillonnage du courant primaire en six segments du pinceau de soudage 1",
	"s112": "Valeur d'échantillonnage du courant maximal primaire de la pince de soudage 1",
	"s113": "Valeur minimale d'affichage du courant primaire de la pince de soudage 1",
	"s114": "Valeur d'affichage du courant primaire de la pince à souder 1, première section",
	"s115": "Valeur d'affichage du courant de la deuxième étape primaire de la pince de soudage 1",
	"s116": "Valeur d'affichage du courant primaire en trois étapes du pinceau de soudage 1",
	"s117": "Valeur d'affichage du courant primaire en quatre segments du pinceau de soudage 1",
	"s118": "Valeur d'affichage du courant primaire en cinq segments du pinceau de soudage 1",
	"s119": "Valeur d'affichage du courant primaire en six segments du pinceau de soudage 1",
	"s120": "Valeur maximale d'affichage du courant primaire de la pince à souder 1",
	"s121": "Valeur de réglage de sortie PWM du courant secondaire minimum de la pince de soudage 1",
	"s122": "Valeur de réglage de la sortie PWM du courant secondaire de la première section de la pince à souder 1",
	"s123": "Valeur de réglage de la sortie PWM du courant secondaire de la deuxième étape de la pince à souder 1",
	"s124": "Valeur de réglage de la sortie PWM du courant secondaire en trois étapes du pinceau de soudage 1",
	"s125": "Valeur de réglage de la sortie PWM du courant secondaire en quatre segments pour la pince à souder 1",
	"s126": "Valeur de réglage de la sortie PWM du courant secondaire en cinq étapes pour le pinceuse 1",
	"s127": "Valeur de réglage de sortie PWM du courant secondaire en six segments pour la pince de soudage 1",
	"s128": "Valeur de réglage de sortie PWM du courant secondaire maximal de la pince de soudure 1",
	"s129": "Valeur d'échantillonnage du courant secondaire minimal du pinceau de soudage 1",
	"s130": "Valeur d'échantillonnage du courant de la première section du pince-soudure 1",
	"s131": "Valeur d'échantillonnage du courant de la deuxième section secondaire de la pince à souder 1",
	"s132": "Valeur d'échantillonnage du courant secondaire en trois phases de la pince de soudage 1",
	"s133": "Valeur d'échantillonnage du courant secondaire du pinceau de soudage en 4 segments",
	"s134": "Valeur d'échantillonnage du courant secondaire en cinq segments de la pince de soudage 1",
	"s135": "Valeur d'échantillonnage du courant secondaire à six segments du pince-soudure 1",
	"s136": "Valeur d'échantillonnage du courant secondaire maximal de la pince de soudage 1",
	"s137": "Valeur d'affichage du courant secondaire minimum du pinceau de soudage 1",
	"s138": "Valeur d'affichage du courant de la première section secondaire du pince-soudure 1",
	"s139": "Valeur d'affichage du courant de la deuxième section secondaire de la pince de soudage 1",
	"s140": "Valeur d'affichage du courant secondaire en trois étapes de la pince à souder 1",
	"s141": "Valeur d'affichage du courant secondaire en quatre segments de la pince de soudage 1",
	"s142": "Valeur d'affichage du courant secondaire en cinq segments du pince-soudure 1",
	"s143": "Valeur d'affichage du courant en six segments pour la pince à souder 1",
	"s144": "Valeur d'affichage du courant secondaire maximal de la pince de soudage 1",
	"s145": "Valeur de réglage de sortie PWM du courant secondaire minimum de la pince à souder 2",
	"s146": "Valeur de réglage de la sortie PWM du courant secondaire de la première section du pinceau de soudage 2",
	"s147": "Valeur de réglage de la sortie PWM du courant secondaire de la deuxième étape du pinceau de soudage 2",
	"s148": "Valeur de réglage de la sortie PWM du courant secondaire en trois segments pour la pince à souder 2",
	"s149": "Valeur de réglage de sortie PWM du courant secondaire en quatre segments pour la pince à souder 2",
	"s150": "Valeur de réglage de sortie PWM du courant secondaire en cinq segments pour la pince à souder 2",
	"s151": "Valeur de réglage de la sortie PWM du courant secondaire en six segments pour la pince de soudage 2",
	"s152": "Valeur de réglage de sortie PWM du courant secondaire maximal de la pince de soudage 2",
	"s153": "Valeur d'échantillonnage du courant secondaire minimum de la pince de soudage 2",
	"s154": "Valeur d'échantillonnage du courant de la première section secondaire du pinceau de soudage 2",
	"s155": "Valeur d'échantillonnage du courant de la deuxième étape secondaire de la pince à souder 2",
	"s156": "Valeur d'échantillonnage du courant secondaire en trois segments du pinceau de soudage 2",
	"s157": "Valeur d'échantillonnage du courant secondaire du pinceau de soudage en 4 segments",
	"s158": "Valeur d'échantillonnage du courant secondaire en cinq segments de la pince de soudage 2",
	"s159": "Valeur d'échantillonnage du courant à six segments du pinceau de soudage 2",
	"s160": "Valeur d'échantillonnage du courant secondaire maximal de la pince de soudage 2",
	"s161": "Valeur d'affichage du courant minimum secondaire du pinceau de soudage 2",
	"s162": "Valeur d'affichage du courant de la première section secondaire du pinceau de soudage 2",
	"s163": "Valeur d'affichage du courant secondaire de la deuxième étape de la pince à souder 2",
	"s164": "Valeur d'affichage du courant en trois étapes du pinceau de soudage 2",
	"s165": "Valeur d'affichage du courant secondaire en 4 segments du pince-soudure 2",
	"s166": "Valeur d'affichage du courant secondaire en cinq segments du pinceau de soudage 2",
	"s167": "Valeur d'affichage du courant à six segments du pinceau de soudage 2 secondaire",
	"s168": "Valeur d'affichage du courant maximal secondaire du pinceau de soudage 2",
	"s169": "Valeur de consigne de pression de sortie de la première section de l'électrode du pince-soudure 1",
	"s170": "Valeur de réglage de la pression de sortie de l'électrode en deux étapes pour la pince à souder 1",
	"s171": "Valeur mesurée de la pression d'une extrémité de l'électrode du pinceau de soudage 1",
	"s172": "Valeur mesurée de la pression de l'électrode en deux étapes du pinceau de soudage 1",
	"s173": "Valeur de sortie de pression de l'électrode 1 du pince-soudure 2",
	"s174": "Valeur de réglage de la pression de sortie du deuxième segment de l'électrode du pinceau de soudage 2",
	"s175": "Valeur affichée de la pression de l'électrode 1 du pinceau de soudage 2 - Valeur mesurée",
	"s176": "Valeur mesurée affichée de la pression de la deuxième section de l'électrode du pince-soudure 2",
	"s177": "Paramètres de calibration du courant primaire",
	"s178": "Paramètres d'étalonnage du courant secondaire",
	"s179": "Mode de sélection des normes de soudage",
	"s180": "Paramètres de réglage fin du courant constant primaire du pince-soudure 1",
	"s181": "Paramètre de réglage fin du courant constant secondaire de la pince à souder 1",
	"s182": "Paramètre de réglage fin du courant constant primaire du pince-soudure 2",
	"s183": "Paramètres de réglage fin du courant constant secondaire de la pince de soudage 2",
	"s184": "Pression ascendante du moule de soudage B",
	"s185": "Pression de meulage de la pince de soudage B",
	"s186": "Fonction de contrôle des points de soudage du pinceau de soudage 1",
	"s187": "Fonction de contrôle des points de soudage du pinceau de soudage 2",
	"s188": "Nombre de points de soudage par pièce répondant à la fonction d'alarme du nombre de points de soudage du procédé sélectionné",
	"s189": "Fonction d'alarme pour le comptage des points de soudure en fonction de la production par lot",
	"s190": "Démarrage du chronométrage immédiatement après le réinitialisation de l'alarme",
	"s191": "Temps de fin de cycle de soudage actuel du pinceau de soudage 1",
	"s192": "Temps de détermination de la fin du cycle de soudage actuel du pince-soudure 2",
	"s193": "Valeur de seuil inférieur du nombre de points de soudure pour la pince à souder 1 par pièce",
	"s194": "Valeur de seuil inférieur du nombre de points de soudure par pièce pour la pince de soudage 2",
	"s195": "Valeur limite supérieure du nombre de points de soudage par pièce pour la pince de soudage 1",
	"s196": "Valeur limite supérieure du nombre de points de soudage par pièce pour la pince de soudage 2",
	"s197": "Valeur de consigne de production pour la classe de pinces à souder 1",
	"s198": "Valeur de consigne de production pour la classe de pinces à souder 2",
	"s199": "Comptage des points de soudure pour la pince de soudage 1 (pièce unique)",
	"s200": "Comptage des points de soudure pour la pince à souder 2 (unité unique)",
	"s201": "Valeur d'alarme de sauvegarde en cas de défaillance du compteur",
	"s202": "Mode de configuration du nombre de pinces à souder",
	"s203": "Valeur de réglage du nombre d'étapes d'amélioration de la pince à souder 1",
	"s204": "Valeur de réglage du niveau d'amélioration en 2 étapes pour la pince de soudage",
	"s205": "Valeur de réglage du nombre de meules pour la pince à souder 1",
	"s206": "Valeur de réglage du nombre de meulage pour la pince à souder 2",
	"s207": "Alerte préalable à l'affûtage du pinceau de soudage 1, valeur de réglage du point de soudure",
	"s208": "Avertissement préalable à l'affûtage du pince-soudure 2 - Valeur de réglage du point de soudure",
	"s209": "Pincer 1 augmentation d'un point de soudure en une étape",
	"s210": "Compensation de puissance du pince-soudure 1",
	"s211": "Compensation de pression de la pince de soudage 1",
	"s212": "Augmenter le nombre de points de soudage de 2 pour la pince à souder 1 étape",
	"s213": "Compensation de puissance du pince-soudure 1 2",
	"s214": "Compensation de pression du pince-soudure 1",
	"s215": "Ajouter 3 points de soudure en une étape avec la pince de soudage 1",
	"s216": "Compensation de puissance de la pince de soudage 1",
	"s217": "Compensation de pression de la pince de soudage 1",
	"s218": "Ajouter 4 points de soudage en une étape avec la pince à souder 1",
	"s219": "Compensation de puissance du pince-soudure 1 4",
	"s220": "Compensation de pression de la pince à souder 1",
	"s221": "Ciseaux à souder 1 étape augmentation de 5 points de soudure",
	"s222": "Compensation de puissance du pinceau de soudage 1 5",
	"s223": "Compensation de pression du pince-soudure 1",
	"s224": "Ajustement de 6 points de soudure supplémentaires par pas pour la pince à souder 1",
	"s225": "Compensation de puissance de la pince à souder 1",
	"s226": "Compensation de pression de la pince de soudage 1",
	"s227": "Pince à souder 1 étape augmentation du nombre de points de soudage 7",
	"s228": "Compensation de puissance de la pince à souder 1 7",
	"s229": "Compensation de pression de la pince à souder 1",
	"s230": "Augmenter le nombre de points de soudage de 8 pour la pince à souder 1 étape",
	"s231": "Compensation de puissance de la pince à souder 1 8",
	"s232": "Compensation de pression du pince-soudure 1 8",
	"s233": "Pincer 1 étape augmentation du nombre de points de soudure 9",
	"s234": "Compensation de puissance du pinceau de soudage 1 9",
	"s235": "Compensation de pression du pince-soudure 1",
	"s236": "Ajout de 1 point de soudure en 2 étapes pour la pince à souder",
	"s237": "Compensation de puissance de la pince à souder 2",
	"s238": "Compensation de pression de la pince à souder 2",
	"s239": "Pince à souder 2 étapes augmentation du nombre de points de soudage 2",
	"s240": "Compensation de puissance de la pince de soudage 2",
	"s241": "Compensation de pression de la pince de soudage 2",
	"s242": "Pince à souder 2 étapes augmentation de points de soudage 3",
	"s243": "Compensation de puissance du pince-soudure 2",
	"s244": "Compensation de pression de la pince à souder 2",
	"s245": "Pince à souder, augmentation de 4 points de soudure en 2 étapes",
	"s246": "Compensation de puissance de la pince à souder 2 4",
	"s247": "Compensation de pression de la pince de soudage 2",
	"s248": "Ajustement en 2 étapes du nombre de points de soudage pour la pince à souder",
	"s249": "Compensation de puissance de la pince à souder 2",
	"s250": "Compensation de pression de la pince de soudage 2",
	"s251": "Pince à souder 2 étapes augmentation de 6 points de soudage",
	"s252": "Compensation de puissance du pince-soudure 2 6",
	"s253": "Compensation de pression de la pince de soudage 2",
	"s254": "Ajustement en 2 étapes du nombre de points de soudure pour la pince à souder 7",
	"s255": "Compensation de puissance du pinceau de soudage 2 7",
	"s256": "Compensation de pression de la pince de soudage 2",
	"s257": "Pince à souder 2 étapes augmentation de points de soudage 8",
	"s258": "Compensation de puissance du pince-soudure 2 8",
	"s259": "Compensation de pression du pinceau de soudure 2",
	"s260": "Pincettes de soudage, augmentation de 9 points de soudage en 2 étapes",
	"s261": "Compensation de puissance du pince-soudure 2 9",
	"s262": "Compensation de pression de la pince à souder 2",
	"s263": "Valeur de réglage de sortie PWM du courant primaire minimum du pinceau de soudage 2",
	"s264": "Valeur de réglage de la sortie PWM du courant primaire de la première section du pinceau de soudage 2",
	"s265": "Valeur de sortie PWM du courant primaire de la deuxième étape du pinceau de soudage 2",
	"s266": "Valeur de réglage de la sortie PWM du courant primaire en trois étapes du pinceau de soudage 2",
	"s267": "Valeur de sortie PWM du courant primaire en quatre segments pour la pince à souder 2",
	"s268": "Valeur de réglage de la sortie PWM du courant primaire en cinq segments pour le pince-soudure 2",
	"s269": "Valeur de réglage de la sortie PWM du courant primaire en six segments pour la pince à souder 2",
	"s270": "Valeur de réglage de sortie PWM du courant primaire maximal de la pince à souder 2",
	"s271": "Valeur d'échantillonnage du courant minimum primaire du pinceau de soudage 2",
	"s272": "Valeur d'échantillonnage du courant primaire de la première section de la pince de soudage 2",
	"s273": "Valeur d'échantillonnage du courant de la deuxième étape primaire de la pince à souder 2",
	"s274": "Valeur d'échantillonnage du courant primaire en trois étapes du pinceau de soudage 2",
	"s275": "Valeur d'échantillonnage du courant primaire en quatre étapes du pinceau de soudage 2",
	"s276": "Valeur d'échantillonnage du courant primaire en cinq segments du pinceau de soudage 2",
	"s277": "Valeur d'échantillonnage du courant primaire en six segments du pince-soudure 2",
	"s278": "Valeur d'échantillonnage du courant primaire maximum de la pince à souder 2",
	"s279": "Valeur d'affichage du courant minimum primaire du pinceau de soudage 2",
	"s280": "Valeur d'affichage du courant primaire de la pince de soudage 2, première section",
	"s281": "Valeur d'affichage du courant primaire de la deuxième étape du pince-soudure 2",
	"s282": "Valeur d'affichage du courant primaire en trois étapes du pinceau de soudage 2",
	"s283": "Valeur d'affichage du courant primaire en quatre segments de la pince de soudage 2",
	"s284": "Valeur d'affichage du courant primaire en cinq segments du pince-soudure 2",
	"s285": "Valeur d'affichage du courant primaire en six segments du pince-soudure 2",
	"s286": "Valeur maximale affichée du courant primaire de la pince à souder 2",
	"s287": "Valeur des 16 bits de poids fort des informations d'alarme sauvegardées en cas de défaillance du compteur",
	"s288": "Fonction d'ajustement UIR sélectionnée",
	"s289": "Fonction d'extension du temps de soudage lors de l'ajustement UIR sélectionnée",
	"s290": "Point de départ de l'ajustement UIR",
	"s291": "Pourcentage maximal d'augmentation du courant d'ajustement UIR",
	"s292": "UIR Ajustement du pourcentage maximal de baisse de courant",
	"s293": "UIR ajustement du temps de montée en pourcentage maximal",
	"s294": "Coefficient de conversion de la valeur échantillonnée de la tension secondaire en valeur affichée",
	"s295": "Fonction de surveillance UIR sélectionnée",
	"s296": "Fonction de sélection du soudage de la carte SD",
	"s297": "Nombre d'enregistrements de soudage dans un fichier de la carte SD",
	"s298": "Nombre de fichiers de soudure dans un dossier de la carte SD",
	"s299": "Fonction de double commande électrique pour le soudage suspendu à grande ouverture",
	"s300": "Surveillance de la résistance secondaire 0: Désactivé 1: Activé",
	"s301": "Paramètre de seuil de résistance sélectionné globalement 0: Désactivé  1: Activé",
	"s302": "Adresse d'offset interne",
	"s303": "Valeur de tension du bus lors de l'étalonnage du courant",
	"s304": "Détection de position de la tension secondaire",
	"s305": "Plage horaire",
	"s306": "Dans les 30 jours",
	"s307": "dans les 60 jours",
	"s308": "dans les 90 jours",
	"s309": "une courbe",
	"s310": "Plage de temps anormale",
	"s311": "La configuration de la courbe d'activité a réussi",
	"s312": "La courbe sélectionnée n'est pas une valeur valide",
	"s313": "Numéro de courbe invalide",
	"s314": "Impossible de trouver la courbe correspondante, suppression échouée",
	"s315": "Échec de la suppression",
	"s316": "Suppression réussie",
	"s317": "Trop d'échantillons, impossible de générer une courbe de référence",
	"s318": "Êtes-vous sûr de vouloir télécharger la courbe de référence actuelle vers le contrôleur ? ",
	"s319": "Êtes-vous sûr de vouloir enregistrer la courbe de référence actuelle dans la bibliothèque des normes ? ",
	"s320": "Courbe de référence non générée, impossible de télécharger",
	"s321": "Numéro de norme invalide (0~143)",
	"s322": "Données de courbe erronées",
	"s323": "Les données de la courbe de référence sont vides, impossible de les enregistrer",
	"s324": "Erreur de traitement de la courbe de référence",
	"s325": "Erreur lors de l'enregistrement de la courbe de référence",
	"s326": "Liste des alarmes",
	"s327": "Échec de l'exécution",
	"s328": "Exécution réussie",
	"s329": "Échec de la vérification",
	"s330": "En cours d'exécution. ..",
	"s331": "Comme le mode de seuil de courant est en mode pourcentage, {{.a}} ne peut être défini que comme un nombre entier. Veuillez vérifier. Si la modification a été effectuée mais n'a pas pris effet, reconnectez l'appareil.",
	"s332": "En mode débogage actuellement, veuillez d'abord désactiver le débogage avant de quitter",
	"s333": "mode de régulation de l'algorithme de courant",
	"s334": "rapide",
	"s335": "point de fin",
	"s336": "configuration du système",
	"s337": "nombre de traitements parallèles de sauvegarde / restauration des paramètres du périphérique",
	"s338": "Répertoire des fichiers de sauvegarde HRC - 670",
	"s339": "numéro de port de connexion HRC - 670",
	"s340": "vue de la configuration du système",
	"s341": "gestion de la configuration du système",
	"s342": "Enregistrer l'exception de paramètre, veuillez patienter et réessayer",
	"s343": "obtenir une exception de configuration système, veuillez patienter et réessayer",
	"s344": "sauvegarder le périphérique avec succès",
	"s345": "le répertoire des fichiers de sauvegarde HRC - 670 ne peut pas être vide",
	"s346": "le chemin d'accès au Répertoire du fichier de sauvegarde HRC - 670 n'existe pas! ",
	"s347": "le nombre de traitements parallèles de sauvegarde / restauration des paramètres du périphérique doit être un entier positif",
	"s348": "le nombre de traitements parallèles de sauvegarde / restauration des paramètres du périphérique doit être compris entre (1 et 8)",
	"s349": "Compatible avec la cartographie sans soudure",
	"s350": "Voyant lumineux",
	"i001": "Gestion des données",
	"i002": "nettoyer les données",
	"i003": "enregistrement de soudage",
	"i004": "enregistrement de courbe",
	"i005": "enregistrement d'alarme",
	"i006": "courbe de référence UIR",
	"i007": "données de bibliothèque canonique",
	"i008": "données de cache canonique",
	"i009": "données du cache système",
	"i010": "modifier l'enregistrement",
	"i011": "enregistrement système",
	"i012": "Remarque: après l'effacement des données sera définitivement irrécupérable, il est fortement recommandé de sauvegarder les données avant de les effacer!! ",
	"i013": "l'utilisateur {{.a}} efface les données de {{.b}}",
	"i014": "effacer les données avec succès",
	"i015": "Échec de l'effacement des données",
	"i016": "nettoyage par le temps",
	"i017": "1 mois",
	"i018": "3 mois",
	"i019": "6 mois",
	"i020": "1 an",
	"i021": "temps de nettoyage:",
	"i022": "nettoyage hors temps",
	"i023": "l'utilisateur {{.a}} nettoie les données de {{.b}}, nettoie la plage:",
	"i024": "sauvegarde automatique des paramètres de l'appareil",
	"i025": "une fois que l'appareil a activé la sauvegarde automatique, sélectionnez l'heure de la sauvegarde automatique",
	"i026": "Nettoyage automatique des enregistrements de données",
	"i027": "Activer le nettoyage automatique, veuillez sélectionner les enregistrements à nettoyer automatiquement",
	"i028": "Activer le nettoyage automatique, veuillez sélectionner la plage horaire pour le nettoyage automatique",
	"i029": "La fonction de nettoyage de cette page permet d'effectuer un nettoyage manuel unique. Si vous souhaitez un nettoyage automatique, rendez-vous dans : Système -> Configuration du système, activez l'option \" Conserver les enregistrements de données de manière cyclique \", puis enregistrez les modifications pour que le changement prenne effet.",
	"i030": "Serveur TCP",
	"i031": "Serveur SSH",
	"i032": "Supprimer définitivement",
	"i033": "Voulez-vous vraiment supprimer cet appareil ? Une fois supprimé, les données ne pourront plus être récupérées.",
	"i034": "Une semaine",
	"h001": "L'utilisateur  {{.a}}  a mis à jour la bibliothèque de normes  {{.b}}  (Nom de la norme :  {{.c}} )",
	"h002": "Erreur lors de la récupération des données du système, veuillez réessayer plus tard",
	"h003": "L'utilisateur  {{.a}}  a créé une bibliothèque de normes  {{.b}}  (Nom de la norme :  {{.c}} )",
	"h004": "L'utilisateur  {{.a}}  a supprimé la bibliothèque de normes  {{.b}}  (Nom de la norme :  {{.c}} )",
	"h005": "L'utilisateur  {{.a}}  a créé la ligne de production  {{.b}} ",
	"h006": "L'utilisateur  {{.a}}  a mis à jour la ligne de production  {{.b}} ",
	"h007": "L'utilisateur  {{.a}}  a supprimé la ligne de production  {{.b}} ",
	"h008": "L'utilisateur  {{.a}}  a rétabli la ligne de production  {{.b}} ",
	"h009": "L'utilisateur  {{.a}}  a créé un nouvel appareil  {{.b}} ",
	"h010": "L'utilisateur  {{.a}}  a mis à jour l'appareil  {{.b}} ",
	"h011": "L'utilisateur  {{.a}}  a supprimé l'appareil  {{.b}} ",
	"h012": "L'utilisateur  {{.a}}  a récupéré l'appareil  {{.b}} ",
	"h013": "L'utilisateur  {{.a}}  a créé l'utilisateur  {{.b}} ",
	"h014": "L'utilisateur  {{.a}}  a mis à jour l'utilisateur  {{.b}} ",
	"h015": "L'utilisateur  {{.a}}  a supprimé l'utilisateur  {{.b}} ",
	"h016": "L'utilisateur  {{.a}}  a restauré l'utilisateur  {{.b}} ",
	"h017": "En raison d'un nombre excessif de tentatives de connexion avec un mot de passe incorrect (dépassant  {{.a}}  fois), le compte  {{.b}}  a été bloqué pendant 20 minutes.",
	"h018": "L'utilisateur  {{.a}}  s'est connecté avec succès",
	"h019": "L'utilisateur  {{.a}}  a mis à jour les paramètres de collecte de courbes de l'appareil  {{.b}} ",
	"h020": "L'utilisateur  {{.a}}  a créé un nouveau rôle  {{.b}} ",
	"h021": "L'utilisateur  {{.a}}  a mis à jour le rôle  {{.b}} ",
	"h022": "L'utilisateur  {{.a}}  a supprimé le rôle  {{.b}} ",
	"h023": "L'utilisateur  {{.a}}  a restauré le rôle  {{.b}} ",
	"h024": "L'utilisateur  {{.a}}  a modifié les autorisations du rôle  {{.b}} ",
	"k001": "Surveillance en temps réel",
	"k002": "Paramètres normalisés",
	"k003": "Gestion de la production",
	"k004": "Paramètres du système",
	"k005": "Enregistrement de soudage",
	"k006": "Enregistrement des alarmes",
	"k007": "Historique des modifications",
	"k008": "Gestion des points de soudure",
	"k009": "Côté équipement",
	"k010": "Bibliothèque hors ligne",
	"k011": "Sélection du pince-soudure",
	"k012": "Valeur du compteur de projection",
	"k013": "Seuil de reconnaissance des projections",
	"k014": "Seuil de la zone temporelle de projection",
	"k015": "Valeur de référence de la résistance",
	"k016": "Seuil minimal de résistance de soudage",
	"k017": "Seuil maximal de résistance de soudage",
	"k018": "Numéro de norme invalide",
	"k019": "La norme  {{.a}}  est chargée avec succès depuis l'appareil",
	"k020": "La norme  {{.a}}  a échoué à charger l'appareil",
	"k021": "La norme  {{.a}}  a été chargée avec succès depuis la base de données hors ligne",
	"k022": "Échec du chargement de la norme  {{.a}}  à partir de la base de données hors ligne",
	"k023": "Télécharger",
	"k024": "Équipement -> Bibliothèque",
	"k025": "Exporter",
	"k026": "Importer",
	"k027": "Calibration de l'électrode 1",
	"k028": "Calibration de l'électrode 2",
	"k029": "Calibration de l'électrode 3",
	"k030": "Calibration de l'électrode 4",
	"k031": "Calibration de l'électrode 5",
	"k032": "Paramètres UIR",
	"k033": "Courbe UIR",
	"k034": "Graphique rectangulaire UIP",
	"k035": "Mise à niveau du logiciel",
	"k036": "Sauvegarde du système",
	"k037": "Configuration de la machine de soudage",
	"k038": "Type de machine à souder",
	"k039": "Soudage par points ordinaire",
	"k040": "Soudage par points robotisé",
	"k041": "Soudage par points ordinaire",
	"k042": "Soudage par points spécialisé",
	"k043": "Soudage suspendu",
	"k044": "Soudure sur mesure",
	"k045": "Soudage par emboutissage",
	"k046": "Soudage de suspension BYD",
	"k047": "Confirmation du point de soudure",
	"k048": "Fermer",
	"k049": "Activer",
	"k050": "Type de transformateur",
	"k051": "Confirmation de la rectification de l'électrode",
	"k052": "Signal de fin de soudage",
	"k053": "Impulsion",
	"k054": "Niveau",
	"k055": "Sélection du mode de seuil de courant",
	"k056": "Mode valeur absolue",
	"k057": "Mode pourcentage",
	"k058": "Mode d'alarme UIP",
	"k059": "Avertissement",
	"k060": "Arrêt",
	"k061": "Tension minimale de la barre omnibus",
	"k062": "Mode de soudage continu",
	"k063": "Tension de référence du bus",
	"k064": "Contrôle à courant constant",
	"k065": "Courant constant secondaire",
	"k066": "Courant constant primaire",
	"k067": "Pression maximale de l'électrode",
	"k068": "Fréquence de sortie du convertisseur",
	"k069": "Configuration des fonctions",
	"k070": "Arrêt d'urgence HMI",
	"k071": "Fonction de la valve proportionnelle",
	"k072": "Priorité aux normes",
	"k073": "L'hôte s'est déconnecté de l'HMI",
	"k074": "Paramètres initiaux",
	"k075": "Sélection par échelle",
	"k076": "Calibrer la pression de l'électrode",
	"k077": "Calibrer le courant primaire",
	"k078": "Calibrer le courant secondaire",
	"k079": "Valeur de calibration",
	"k080": "Valeur de consigne%",
	"k081": "Valeur mesurée KN",
	"k082": "Fonction sélectionnée",
	"k083": "Surveillance UIR",
	"k084": "Compensation du temps",
	"k085": "Heure de début",
	"k086": "Paramètres fonctionnels",
	"k087": "Limite supérieure de régulation du courant",
	"k088": "Limite inférieure de régulation du courant",
	"k089": "Seuil de la porte temporelle des projections",
	"k090": "Seuil de détection des projections",
	"k091": "Limite supérieure de prolongation du temps",
	"k092": "Coefficient de tension secondaire",
	"k093": "Paramètre de seuil de résistance sélectionné globalement",
	"k094": "Surveillance de la résistance secondaire",
	"k095": "Seuil minimal de résistance de soudage",
	"k096": "Seuil maximal de résistance de soudage",
	"k097": "Plafond de prolongation du temps",
	"k098": "Arrêter l'enregistrement de UIR",
	"k099": "Nombre de points de soudure",
	"k100": "Veine variqueuse sélectionnée",
	"k101": "Temps de soudage",
	"k102": "Numéro de point de soudure",
	"k103": "Supprimer la courbe",
	"k104": "Générer une courbe de référence",
	"k105": "->Contrôleur",
	"k106": "Sélection de la fonction UIP",
	"k107": "Valeur de référence UIP",
	"k108": "Bandes de tolérance sur la UIP",
	"k109": "Bande de tolérance inférieure de l'UIP",
	"k110": "Mise à niveau du contrôleur",
	"k111": "Note : Ne débranchez pas l'alimentation pendant la mise à niveau du contrôleur",
	"k112": "Firmware",
	"k113": "Veuillez sélectionner le fichier de firmware à mettre à niveau",
	"k114": "Sélectionner un fichier",
	"k115": "Mise à niveau",
	"k116": "Réinitialiser les paramètres d'usine",
	"k117": "Note : Le contrôleur sera réinitialisé aux paramètres d'usine, les données existantes seront perdues",
	"k118": "Option",
	"k119": "Paramètres du système",
	"k120": "Restaurer",
	"k121": "Paramètres d'étalonnage",
	"k122": "Impédance du circuit secondaire",
	"k123": "Soudage autorisé",
	"k124": "Courant secondaire maximal",
	"k125": "Mode de sortie de pression",
	"k126": "Temps de soudage maximal",
	"k127": "Plage de variation maximale de la largeur d'impulsion",
	"k128": "Impédance normale",
	"k129": "Impédance trop élevée",
	"k130": "Petite impédance",
	"k131": "Fonction de contrôle d'E/S",
	"k132": "Préférence du contrôleur",
	"k133": "Préférence RS-485",
	"k134": "Priorité DeviceNet",
	"k135": "Privilégier MDTCP",
	"k136": "Privilège ABCC",
	"k137": "Mode de travail prioritaire",
	"k138": "Programmeur prioritaire",
	"k139": "Priorité effective",
	"k140": "Priorité au groupe standard",
	"k141": "Paramètres de l'UIP",
	"k142": "Chargement de l'appareil réussi",
	"k143": "Chargé avec succès depuis la bibliothèque hors ligne",
	"k144": "Échec du chargement du périphérique",
	"k145": "Chargement depuis la base hors ligne échoué",
	"k146": "Détection de la tension secondaire",
	"k147": "Détection de la tension secondaire",
	"k148": "Ajustement UIR",
	"k149": "Fréquence de l'onduleur",
	"k150": "Sélection de l'étalonnage du courant primaire",
	"k151": "Défaut du système",
	"k152": "Auto-calibration par l'utilisateur",
	"k153": "Fréquence de l'onduleur",
	"k154": "Coefficient de réglage primaire",
	"k155": "Sélection d'étalonnage du courant secondaire",
	"k156": "Réglage PWM",
	"k157": "Valeur mesurée (KA)",
	"k158": "Valeur d'échantillonnage",
	"k159": "Coefficient de réglage primaire",
	"k160": "Coefficient de réglage secondaire",
	"k161": "Coefficient de réglage secondaire",
	"k162": "Valeur de calibration primaire",
	"k163": "Valeur de recalibrage secondaire",
	"k164": "Pression de l'électrode",
	"k165": "Électrode primaire",
	"k166": "Électrode secondaire",
	"k167": "Compteur de l'électrode 1",
	"k168": "Compteur d'électrode 2",
	"k169": "Usinage de l'électrode 1",
	"k170": "Rectification de l'électrode 2",
	"k171": "Informations sur la pièce",
	"k172": "Numéro de lot de production",
	"k173": "Opérateur",
	"k174": "Démarrage de la norme 1",
	"k175": "Démarrer la norme 2",
	"k176": "Requête",
	"k177": "Séries de liens normalisés",
	"k178": "Démarrage prolongé jusqu'à la pré-pression",
	"k179": "Sélection de fonction",
	"k180": "Fonction d'augmentation pas à pas",
	"k181": "Compensation de puissance(%)",
	"k182": "Fonction de soudage de réparation",
	"k183": "Fonction de détection",
	"k184": "Nombre maximal de soudages de réparation",
	"k185": "Démarrer la fonction 2",
	"k186": "Alarme du compteur de points de soudure par pièce",
	"k187": "Alerte de comptage de production par lot",
	"k188": "Comptage immédiat après la réinitialisation de l'alarme",
	"k189": "Contrôle des points de soudure par processus de pinces à souder",
	"k190": "Limite inférieure du point de soudure par procédé de pince de soudage",
	"k191": "Limite supérieure du point de soudure du pince-soudure",
	"k192": "Temps de jugement de fin de point de soudure du pinceau à souder (en secondes)",
	"k193": "Nombre de points de soudure par pièce",
	"k194": "Production par équipe",
	"k195": "Nombre total de productions",
	"k196": "Nombre total de points de soudure",
	"k197": "Valeur actuelle",
	"k198": "Remise à zéro",
	"k199": "Niveau d'amélioration des pas",
	"k200": "Nombre de meules",
	"k201": "Alerte préalable à l'affûtage",
	"k202": "Pression ascendante de rectification",
	"k203": "Pression de descente pour le meulage",
	"k204": "Étape d'augmentation 1",
	"k205": "Étape d'augmentation 2",
	"k206": "Pas d'augmentation 3",
	"k207": "Étape d'augmentation 4",
	"k208": "Étape d'augmentation de 5",
	"k209": "Pas d'augmentation de 6",
	"k210": "Pas d'augmentation 7",
	"k211": "Augmentation de pas 8",
	"k212": "Pas d'augmentation 9",
	"k213": "Nom de la pièce",
	"k214": "Erreur lors du chargement des données de la courbe UIP",
	"k215": "Erreur de configuration pour l'obtention hors ligne",
	"k216": "Erreur lors de la configuration de l'obtention de l'appareil",
	"k217": "Valeur de consigne de la production par équipe de pinces à souder",
	"k218": "Valeur de consigne",
	"k219": "Compensation de pression(%)",
	"k220": "Veuillez sélectionner une plage de dates",
	"k221": "Date",
	"k222": "temps",
	"k223": "Contenu de l'alarme",
	"k224": "enregistrement",
	"k225": "Date de création",
	"k226": "Code VIN du châssis",
	"k227": "Soudure 1 (KA/ms)",
	"k228": "Soudage 2 (KA/ms)",
	"k229": "Soudage 3 (KA/ms)",
	"k230": "Numéro de pince à souder actuellement utilisé",
	"k231": "Énergie (KJ)",
	"k232": "Largeur d'impulsion de sortie (%)",
	"k233": "Tension secondaire (V)",
	"k234": "Résistance secondaire (μOhm)",
	"k235": "Valeur UIP",
	"k236": "Tous",
	"k237": "Pas d'alarme",
	"k238": "Alarme activée",
	"k239": "Avant modification",
	"k240": "Modifié",
	"k241": "Numéro de point de soudure",
	"k242": "Numéro de ligne",
	"k243": "Pression (N)",
	"k244": "Épaisseur de la plaque (mm)",
	"k245": "Modèle de véhicule",
	"k246": "Informations sur les points de soudure",
	"k247": "Matériau de la plaque 1",
	"k248": "Épaisseur de la plaque 1 (mm)",
	"k249": "Matériau de la plaque 2",
	"k250": "Épaisseur de la plaque 2 (mm)",
	"k251": "Matériau de la plaque 3",
	"k252": "Épaisseur de la plaque 3 (mm)",
	"k253": "Matériau de la plaque 4",
	"k254": "Épaisseur de la plaque 4 (mm)",
	"k255": "Se produit",
	"k256": "Réinitialiser",
	"k257": "Contenu",
	"k258": "Modèle de véhicule",
	"k259": "Numéro de cartographie du point de soudure",
	"k260": "Paramètre de requête anormal",
	"k261": "Appareil actuel",
	"k262": "Électrode 1",
	"k263": "Électrode 2",
	"k264": "Bibliothèque -> Appareils",
	"k265": "La bibliothèque hors ligne n'est pas configurée, la synchronisation n'est pas autorisée",
	"k266": "La fonction d'exportation fonctionne anormalement",
	"k267": "Lecture anormale des données de norme",
	"k268": "Clé primaire",
	"k269": "Nom de la pièce",
	"k270": "Temps de précharge ms",
	"k271": "Temps de suivi en ms",
	"k272": "Courant de pré-soudage KA",
	"k273": "Temps de pré-soudage en ms",
	"k274": "Temps de refroidissement 0 ms",
	"k275": "Temps de montée lente ms",
	"k276": "Courant de soudage 1 KA",
	"k277": "Temps de soudage 1 en ms",
	"k278": "Temps de refroidissement 1 ms",
	"k279": "Courant de soudage 2 KA",
	"k280": "Temps de soudage 2 en ms",
	"k281": "Temps de refroidissement 2 ms",
	"k282": "Courant de soudage 3 KA",
	"k283": "Temps de soudage 3 ms",
	"k284": "Temps de descente lente ms",
	"k285": "Temps de refroidissement 3 ms",
	"k286": "Courant de soudage postérieur KA",
	"k287": "Temps de soudage ultérieur en ms",
	"k288": "Temps de maintien ms",
	"k289": "Temps d'arrêt ms",
	"k290": "Coefficient d'augmentation par pas",
	"k291": "Nombre de répétitions",
	"k292": "Comptage actuel des points de soudure",
	"k293": "Tension de condensateur primaire",
	"k294": "État des entrées (In00~In31)",
	"k295": "État de la sortie 0 (Out00~Out31)",
	"k296": "Mode de fonctionnement actuel du système",
	"k297": "Compteur de points de soudure pour la pince à souder 1 (pièce unique)",
	"k298": "Compteur de points de soudure pour la pince de soudage 2 (pièce unique)",
	"k299": "Compteur de production pour la production de la classe 1 des pinces de soudage",
	"k300": "Valeur comptée de la production en classe 2 pour les pinces de soudage",
	"k301": "Compteur de production total du pince-soudure 1",
	"k302": "Compteur de production total du pince à souder 2",
	"k303": "Compteur total de points de soudage pour la pince de soudage 1",
	"k304": "Compteur total de points de soudure du pinceau de soudure 2",
	"k305": "Compteur de niveau d'amélioration en une étape pour le pince-soudure 1",
	"k306": "Compteur de niveau d'amélioration en 2 étapes pour la pince à souder",
	"k307": "Compteur du nombre de meulages du pinceau de soudure 1",
	"k308": "Compteur de nombre de retouches du pinceau de soudage 2",
	"k309": "Numéro de norme actuellement utilisé pour la pince à souder 2",
	"k310": "Nombre d'enregistrements d'alarmes historiques",
	"k311": "Numéro de pinces à souder actuellement utilisé",
	"k312": "Énergie",
	"k313": "Capacité de charge",
	"k314": "Tension secondaire",
	"k315": "Résistance secondaire",
	"k316": "Signal d'alarme",
	"k317": "Démarrer la série de connexion normative 1",
	"k318": "Activation de la fonction de précharge retardée sélectionnée",
	"k319": "Fonction d'augmentation par étapes sélectionnée",
	"k320": "Pression ascendante de la pince de soudage A pour le réglage du moule",
	"k321": "Fonction de soudage de réparation sélectionnée",
	"k322": "Sélection de la fonction IO",
	"k323": "Pression de meulage du pinceau de soudage A",
	"k324": "Temps de décision de fin de soudure par pince",
	"k325": "Nombre d'onduleurs",
	"k326": "Détection par rétroaction de courant",
	"k327": "Paramétrage de la priorité des fonctions de contrôle",
	"k328": "Valeur de réglage du nombre d'étapes d'augmentation",
	"k329": "Compteur de niveau d'amélioration par étape",
	"k330": "Valeur de réglage du nombre de meules",
	"k331": "Compteur de nombre de rectifications",
	"k332": "Valeur de réglage de l'avertissement préliminaire de meulage des points de soudure",
	"k333": "Augmenter le nombre de points de soudure 1",
	"k334": "Compensation de puissance 1",
	"k335": "Compensation de pression 1",
	"k336": "Nombre de points de soudure augmenté par étape 2",
	"k337": "Compensation de puissance 2",
	"k338": "Compensation de pression 2",
	"k339": "Augmentation progressive du nombre de points de soudure 3",
	"k340": "Compensation de puissance 3",
	"k341": "Compensation de pression 3",
	"k342": "Augmentation progressive du nombre de points de soudure 4",
	"k343": "Compensation de puissance 4",
	"k344": "Compensation de pression 4",
	"k345": "Nombre de points de soudage augmenté par étape 5",
	"k346": "Compensation de puissance 5",
	"k347": "Compensation de pression 5",
	"k348": "Augmentation progressive du nombre de points de soudure 6",
	"k349": "Compensation de puissance 6",
	"k350": "Compensation de pression 6",
	"k351": "Augmentation progressive du nombre de points de soudure 7",
	"k352": "Compensation de puissance 7",
	"k353": "Compensation de pression 7",
	"k354": "Augmentation progressive du nombre de points de soudure 8",
	"k355": "Compensation de puissance 8",
	"k356": "Compensation de pression 8",
	"k357": "Augmenter le nombre de points de soudure de 9",
	"k358": "Pression ascendante de meulage",
	"k359": "Pression de descente pour le meulage",
	"k360": "Configuration des pinces à souder",
	"k361": "Mode de configuration du pince-soudure",
	"k362": "Pinces à souder individuelles",
	"k363": "Pincettes doubles de soudage",
	"k364": "Pinces à souder multiples",
	"k365": "Mode d'ouverture maximale des pinces à souder",
	"k366": "Maintenir le style",
	"k367": "Pulsation",
	"k368": "État des bras d'électrode en cas de coupure de courant",
	"k369": "Xiao Zhang Kai",
	"k370": "Grand écart",
	"k371": "Type de valve d'air pour l'ouverture large des pinces de soudage",
	"k372": "Commande électrique simple",
	"k373": "Double commande électrique",
	"k374": "Xiao Zhang a activé le démarrage retardé",
	"k375": "Soudage autorisé en cas de manque d'eau de refroidissement",
	"k376": "Fonction de surveillance de l'écoulement d'eau de la pince à souder 2",
	"k377": "L'utilisateur  {{.a}}  a mis à jour les paramètres de la courbe de collecte, ID de l'appareil :  {{.b}} ",
	"k378": "L'utilisateur  {{.a}}  a téléchargé la bibliothèque de normes DIP pour l'équipement  {{.b}}  :  {{.c}} ",
	"k379": "X",
	"k380": "Y",
	"k381": "Z",
	"k382": "The solder joint mapping number already exists",
	"k383": "Nouveau point de soudure ajouté avec succès",
	"k384": "Échec de la nouvelle soudure",
	"k385": "Modification du point de soudure réussie",
	"k386": "Échec de l'édition du point de soudure",
	"k387": "Échec de l'enregistrement des informations d'extension des points de soudure",
	"k388": "Échec de la requête des informations d'extension des points de soudure",
	"k389": "Téléchargement échoué, l'appareil {{.a}} est peut-être hors ligne",
	"k390": "Le nombre de points de soudure est invalide ou supérieur à 2000 points",
	"k391": "UIR n'a pas encore commencé",
	"k392": "L'enregistrement UIR a commencé, pas besoin de recommencer",
	"k393": "Commencer à enregistrer le UIR",
	"k394": "Arrêter l'enregistrement UIR",
	"k395": "Données de requête anormales",
	"k396": "Courbe sélectionnée",
	"k397": "Générer la courbe de référence",
	"k398": "->Contrôleur",
	"k399": "->PC",
	"k400": "Un paquet de courbes",
	"k401": "Chargement réussi",
	"k402": "Aucune alarme, pas besoin de réinitialisation",
	"k403": "Lecture anormale des paramètres système",
	"k404": "Le mode de seuil actuel du fichier importé ne correspond pas à l'appareil importé",
	"w001": "Courant de soudage 1 dépassant la limite",
	"w002": "Courant de soudage 1 trop faible",
	"w003": "Courant de soudage 2 dépassant la limite",
	"w004": "Le courant de soudage 2 est trop faible",
	"w005": "Courant de soudage 3 dépassant la limite",
	"w006": "Le courant de soudage 3 est trop faible",
	"w007": "Défaillance de l'IGBT",
	"w008": "Désactivation d'urgence",
	"w009": "Température excessive du transformateur 1",
	"w010": "Température de la source de fréquence moyenne dépassant la limite",
	"w011": "Erreur du commutateur d'écoulement d'eau",
	"w012": "Erreur de commutateur de pression",
	"w013": "Temps d'attente autorisé pour le soudage",
	"w014": "Dépassement de temps de l'entrée programmable 1",
	"w015": "Dépassement de délai de l'entrée programmable 2",
	"w016": "Dépassement de temps pour l'entrée programmable 3",
	"w017": "Erreur dans le tableau des paramètres de mémoire",
	"w018": "Dépassement du délai de charge du condensateur primaire",
	"w019": "Erreur de fermeture du commutateur de pédale lors de l'alimentation du système",
	"w020": "Tension de condensateur primaire trop basse",
	"w021": "Erreur d'écriture des données ferroélectriques",
	"w022": "Erreur dans la configuration du temps de précharge",
	"w023": "Défaillance de communication RS485",
	"w024": "Soudage suspendu : Alarme de commutation d'eau pour le pince-soudure 2",
	"w025": "Protection par grille",
	"w026": "Erreur de configuration du type de transformateur",
	"w027": "Erreur de configuration du mode courant constant",
	"w028": "Paramètre de courant secondaire incorrect",
	"w029": "Interdiction d'alarme d'interface de soudage",
	"w030": "Protection de la sortie de courant",
	"w031": "Température excessive du transformateur 2",
	"w032": "Erreur de rétroaction de courant",
	"w033": "Le nombre actuel de points de soudage du pinceau de soudage 1 a atteint la valeur définie du nombre de points de soudage par pièce",
	"w034": "Le nombre réel de points de soudage du pince-soudure 1 dépasse la limite supérieure de points de soudage par pièce",
	"w035": "Le nombre réel de points de soudage du pinceau 1 est inférieur à la limite inférieure des points de soudage par pièce",
	"w036": "La production de la classe 1 de pinces de soudage atteint la valeur définie",
	"w037": "Avertissement précoce de meulage de la pince de soudage 1",
	"w038": "Alerte d'affûtage du pinceau de soudage 1",
	"w039": "Alerte de remplacement du pince-soudure 1",
	"w040": "Avertissement préalable au remplacement de la pince de soudage 1",
	"w041": "Réserver01",
	"w042": "Le nombre actuel de points de soudage du pinceau de soudage 2 a atteint la valeur définie pour le nombre de points de soudage par pièce",
	"w043": "Le nombre réel de points de soudure du pinceau de soudage 2 dépasse la limite supérieure des points de soudure par pièce",
	"w044": "Le nombre réel de points de soudure du pinceau de soudure 2 est inférieur à la limite inférieure des points de soudure par pièce",
	"w045": "Production de la pince à souder 2 atteint la valeur définie",
	"w046": "Alerte préliminaire au meulage du pinceau de soudage 2",
	"w047": "Alerte de rectification de la pince de soudage 2",
	"w048": "Alerte de remplacement du pince-soudure 2",
	"w049": "Avertissement préliminaire de remplacement du pince-soudure 2",
	"w050": "Réserver49",
	"w051": "Réserver50",
	"w052": "Réserver51",
	"w053": "Réserver52",
	"w054": "Réserver53",
	"w055": "Réserver 54",
	"w056": "Réserver55",
	"w057": "Réserver56",
	"w058": "Réserver57",
	"w059": "Réserver58",
	"w060": "Réserver59",
	"w061": "Erreur RTC",
	"w062": "Erreur d'écriture sur la carte SD",
	"w063": "Erreur de paramètre d'étalonnage",
	"w164": "Erreur de paramètre d'incrémentation",
	"w064": "Contact défectueux du fil de rétroaction de courant",
	"w065": "Alerte de résistance de soudage trop élevée",
	"w066": "Alerte de résistance de soudage trop faible",
	"w067": "Anomalie du câble de tension secondaire",
	"w168": "UIP légèrement inférieur",
	"w069": "UIP excessivement élevé",
	"w068": "Soudage anormal adaptatif",
	"w097": "Alerte de projection de soudure",
	"w098": "Largeur d'impulsion de sortie trop importante",
	"w099": "UIP est légèrement inférieur",
	"w100": "UIP légèrement élevé",
	"z001": "{{.a}}(Plage de valeurs  {{.b}}~{{.c}}{{.d}} ) Valeur cible définie :  {{.e}} ",
	"z002": "Ce n'est pas un nombre à virgule flottante: {{.a}}",
	"z003": "Pas une chaîne de caractères:{{.a}}",
	"z004": "La longueur n'est pas {{.a}}, la longueur est {{.b}}",
	"z005": "{{.a}} Ce contrôleur de méthode n'a pas été implémenté",
	"z006": "Hors ligne",
	"z007": "En ligne",
	"z008": "Anomalie",
	"z009": "Supprimé",
	"z010": "{{.a}} Erreur de saisie",
	"z011": "Erreur de validation de l'entrée",
	"z012": "Journal d'alarmes",
	"z013": "Débogage du programme",
	"z014": "Gestion de base de données",
	"z015": "Historique des modifications",
	"z016": "Gestion de la production",
	"z017": "Paramètres normatifs",
	"z018": "Enregistrement de soudage",
	"z019": "Surveillance en temps réel",
	"z020": "Paramètres du système",
	"z021": "Non activé",
	"z022": "Normal",
	"z023": "Congelé",
	"z024": "Supprimé",
	"z025": "Administrateur",
	"z026": "Opérateur",
	"z027": "Consultant",
	"z028": "Numéro de norme hors de la plage (0-959)",
	"z029": "Numéro de norme hors limite (0-63)",
	"z030": "Le contrôleur 1 n'est pas un entier valide",
	"z031": "Le contrôleur 2 n'est pas un entier valide",
	"z032": "Le numéro de norme 1 n'est pas un entier valide",
	"z033": "Le numéro de norme 2 n'est pas un entier valide",
	"z034": "Même norme, comparaison non autorisée",
	"z035": "Nom de la pièce",
	"z036": "Numéro de lot de production",
	"z037": "Opérateur",
	"z038": "Erreur de norme hors ligne de la requête",
	"z039": "Ce n'est pas un entier : {{.a}}",
	"z040": "Reconnexion en cours. ..",
	"g001": "Nombre total de points de soudure du support d'électrode 3",
	"g002": "Nombre total de soudures du porte électrode 4",
	"g003": "Nombre total de points de soudure du support d'électrode 5",
	"g004": "Valeur de réglage pour l'incrément de niveau en 3 étapes des pinces de soudage",
	"g005": "Valeur de réglage pour la fréquence de broyage des pinces de soudage 3",
	"g006": "Valeur de réglage du point de soudure de pré-alarme de broyage de torche de soudure 3",
	"g007": "Valeur de comptage de l'incrément en 3 étapes pour les pinces de soudage",
	"g008": "Nombre de temps de broyage pour le support d'électrode 3",
	"g009": "Valeur de réglage pour l'incrément de niveau en 4 étapes des pinces de soudage",
	"g010": "Valeur de réglage pour la fréquence de broyage des pinces de soudage 4",
	"g011": "Valeur de réglage du point de soudure pré-alarme de broyage de torche de soudure 4",
	"g012": "Valeur de comptage de l'incrément de niveau en 4 étapes pour les pinces de soudage",
	"g013": "Nombre de temps de broyage pour les pinces de soudage 4",
	"g014": "Définir la valeur pour l'incrément en 5 étapes du support d'électrode",
	"g015": "Valeur de réglage pour la fréquence de broyage du porte électrode 5",
	"g016": "Valeur de réglage du point de soudure pré-alarme de broyage de torche de soudure 5",
	"g017": "Valeur de comptage de l'incrément en 5 étapes pour les pinces de soudage",
	"g018": "Nombre de temps de broyage pour le porte électrode 5",
	"g019": "Torche de soudage 3 étapes nombre de points de soudage incrémentaux 1",
	"g020": "Torche de soudage 3 compensation de puissance 1",
	"g021": "Torche de soudage 3 compensation de pression 1",
	"g022": "Torche de soudage 3 étapes nombre de points de soudage incrémentaux 2",
	"g023": "Torche de soudage 3 compensation de puissance 2",
	"g024": "Torche de soudage 3 compensation de pression 2",
	"g025": "agrafes de soudure augmentation en 3 étapes du nombre de points de soudure 3",
	"g026": "Torche de soudage 3 compensation de puissance 3",
	"g027": "Torche de soudage 3 compensation de pression 3",
	"g028": "pinces de soudage 3 étapes nombre de points de soudure incrémentaux 4",
	"g029": "Torche de soudage 3 compensation de puissance 4",
	"g030": "Torche de soudage 3 compensation de pression 4",
	"g031": "pinces de soudure 3 étapes nombre de points de soudure incrémentaux 5",
	"g032": "Torche de soudage 3 compensation de puissance 5",
	"g033": "Torche de soudage 3 compensation de pression 5",
	"g034": "Torche de soudure 3 étapes nombre de points de soudure incrémentaux 6",
	"g035": "Torche de soudage 3 compensation de puissance 6",
	"g036": "Torche de soudage 3 compensation de pression 6",
	"g037": "Torche de soudure 3 étapes nombre de points de soudure incrémentaux 7",
	"g038": "Porte électrode 3 compensation de puissance 7",
	"g039": "Torche de soudage 3 compensation de pression 7",
	"g040": "Torche de soudure 3 étapes nombre de points de soudure incrémentaux 8",
	"g041": "Torche de soudage 3 compensation de puissance 8",
	"g042": "Supporteur d'électrode 3 compensation de pression 8",
	"g043": "pinces de soudure 3 étapes nombre de points de soudure incrémentaux 9",
	"g044": "Porte électrode 3 compensation de puissance 9",
	"g045": "Torche de soudage 3 compensation de pression 9",
	"g046": "Torche de soudure 4 étapes nombre de points de soudure incrémentaux 1",
	"g047": "Torche de soudage 4 compensation de puissance 1",
	"g048": "Torche de soudage 4 compensation de pression 1",
	"g049": "Augmentation en 4 étapes du nombre de points de soudure 2",
	"g050": "Porte électrode 4 compensation de puissance 2",
	"g051": "Torche de soudage 4 compensation de pression 2",
	"g052": "Torche de soudage 4 étapes nombre de points de soudage incrémentaux 3",
	"g053": "Torche de soudage 4 compensation de puissance 3",
	"g054": "torche de soudage 4 compensation de pression 3",
	"g055": "pinces de soudure 4 étapes nombre de points de soudure incrémentaux 4",
	"g056": "Torche de soudage 4 compensation de puissance 4",
	"g057": "Supporteur d'électrode 4 compensation de pression 4",
	"g058": "pinces de soudure 4 étapes nombre de points de soudure incrémentaux 5",
	"g059": "Porte électrode 4 compensation de puissance 5",
	"g060": "Torche de soudage 4 compensation de pression 5",
	"g061": "pinces de soudure 4 étapes nombre de points de soudure incrémentaux 6",
	"g062": "Porte électrode 4 compensation de puissance 6",
	"g063": "torche de soudage 4 compensation de pression 6",
	"g064": "pinces de soudure 4 étapes nombre de points de soudure incrémentaux 7",
	"g065": "Porte électrode 4 compensation de puissance 7",
	"g066": "torche de soudage 4 compensation de pression 7",
	"g067": "Torche de soudure 4 étapes nombre de points de soudure incrémentaux 8",
	"g068": "Porte électrode 4 compensation de puissance 8",
	"g069": "pinces de soudage 4 compensation de pression 8",
	"g070": "Torche de soudage 4 étapes nombre de points de soudage incrémentaux 9",
	"g071": "Torche de soudage 4 compensation de puissance 9",
	"g072": "Porte électrode 4 compensation de pression 9",
	"g073": "Torche de soudage 5 étapes nombre de points de soudage incrémentaux 1",
	"g074": "Torche de soudage 5 compensation de puissance 1",
	"g075": "Torche de soudage 5 compensation de pression 1",
	"g076": "Pinces de soudage Augmentation en 5 étapes du nombre de points de soudure 2",
	"g077": "Porte électrode 5 compensation de puissance 2",
	"g078": "Torche de soudage 5 compensation de pression 2",
	"g079": "Torche de soudure 5 étapes nombre de points de soudure incrémentaux 3",
	"g080": "Torche de soudage 5 compensation de puissance 3",
	"g081": "torche de soudage 5 compensation de pression 3",
	"g082": "Torche de soudage 5 étapes nombre de points de soudage incrémentaux 4",
	"g083": "Torche de soudage 5 compensation de puissance 4",
	"g084": "Torche de soudage 5 compensation de pression 4",
	"g085": "Torche de soudure 5 étapes augmenter le nombre de points de soudure 5",
	"g086": "Porte électrode 5 compensation de puissance 5",
	"g087": "torche de soudage 5 compensation de pression 5",
	"g088": "pinces de soudure 5 étapes nombre de points de soudure incrémentaux 6",
	"g089": "torche de soudage 5 compensation de puissance 6",
	"g090": "torche de soudage 5 compensation de pression 6",
	"g091": "pinces de soudure 5 étapes nombre de points de soudure incrémentaux 7",
	"g092": "Porte électrode 5 compensation de puissance 7",
	"g093": "Torche de soudage 5 compensation de pression 7",
	"g094": "pinces de soudure 5 étapes nombre de points de soudure incrémentaux 8",
	"g095": "Porte électrode 5 compensation de puissance 8",
	"g096": "Supporteur d'électrode 5 compensation de pression 8",
	"g097": "Les pinces de soudure augmentent le nombre de points de soudure de 9 en 5 étapes",
	"g098": "Torche de soudage 5 compensation de puissance 9",
	"g099": "Supporteur d'électrode 5 compensation de pression 9",
	"g100": "Paramètre de coupe à courant constant secondaire du porte électrode 3",
	"g101": "Torche de soudage 4 paramètre de coupe à courant constant primaire",
	"g102": "Torche de soudage 4 paramètre de coupe à courant constant secondaire",
	"g103": "Torche de soudage 5 paramètre de coupe à courant constant primaire",
	"g104": "Torche de soudage 5 paramètre de coupe à courant constant secondaire",
	"g105": "Valeur minimale de réglage de sortie de courant primaire PWM pour le support d'électrode 3",
	"g106": "Valeur de réglage de sortie de courant primaire PWM de la torche de soudage 3",
	"g107": "Valeur de réglage de sortie PWM de courant primaire secondaire de torche de soudage 3",
	"g108": "Valeur de réglage de sortie de courant primaire PWM à trois étages de la torche de soudage 3",
	"g109": "Valeur de réglage de sortie de courant primaire PWM à quatre étages de la torche de soudage 3",
	"g110": "Valeur de réglage de sortie de courant primaire PWM à cinq étages de la torche de soudage 3",
	"g111": "Valeur de réglage de sortie de courant primaire PWM à six étages de la torche de soudage 3",
	"g112": "Valeur de réglage de sortie PWM de courant primaire maximum pour le porte électrode 3",
	"g113": "Valeur minimale d'échantillonnage de courant du porte électrode 3 primaire",
	"g114": "Valeur d'échantillonnage courante de la section primaire du porte électrode 3",
	"g115": "Valeur d'échantillonnage courante du support d'électrode 3, étape primaire 2",
	"g116": "Valeur d'échantillonnage courante du support d'électrode 3, étape primaire, troisième segment",
	"g117": "Valeur d'échantillonnage courant de la quatrième étape du circuit primaire du porte électrode 3",
	"g118": "Valeur d'échantillonnage courante du support d'électrode 3 au cinquième stade primaire",
	"g119": "Valeur d'échantillonnage courante du support d'électrode 3 au niveau primaire, à six étapes",
	"g120": "Valeur maximale d'échantillonnage de courant du support d'électrode 3 au niveau primaire",
	"g121": "Valeur d'affichage du courant primaire minimum pour le support d'électrode 3",
	"g122": "Valeur d'affichage courante de la torche de soudage 3 étape primaire 1",
	"g123": "Valeur d'affichage du courant secondaire pour le support d'électrode 3 (étage primaire)",
	"g124": "Valeur d'affichage du courant principal à trois étages de la torche de soudage 3",
	"g125": "Valeur d'affichage du courant principal à quatre étages de la torche de soudage 3",
	"g126": "Valeur d'affichage du courant dans la cinquième étape du circuit primaire du porte électrode 3",
	"g127": "Valeur d'affichage du courant primaire à six étages de la torche de soudage 3",
	"g128": "Valeur d'affichage du courant primaire maximum pour le support d'électrode 3",
	"g129": "Valeur minimale de réglage de sortie de courant secondaire PWM pour le support d'électrode 3",
	"g130": "Valeur de réglage de sortie PWM de courant secondaire pour le support d'électrode 3, section 1",
	"g131": "Valeur de réglage de sortie PWM de courant secondaire pour le support d'électrode 3, section 2",
	"g132": "Valeur de réglage de sortie de courant secondaire PWM à trois étages de la torche de soudage 3",
	"g133": "Valeur de réglage de sortie de courant secondaire PWM pour la pince de soudage 3, section 4",
	"g134": "Valeur de réglage de sortie de courant secondaire PWM à cinq étages de la torche de soudage 3",
	"g135": "Valeur de réglage de sortie de courant secondaire PWM à six étages de la torche de soudage 3",
	"g136": "Valeur de réglage maximale de sortie PWM de courant secondaire pour le support d'électrode 3",
	"g137": "Valeur minimale d'échantillonnage de courant du support d'électrode 3 secondaire",
	"g138": "Valeur d'échantillonnage de courant secondaire de la torche de soudage 3",
	"g139": "Valeur d'échantillonnage de courant secondaire du support d'électrode 3",
	"g140": "Valeur d'échantillonnage de courant secondaire à trois étages de la torche de soudage 3",
	"g141": "Valeur d'échantillonnage de courant secondaire à quatre étages de la torche de soudage 3",
	"g142": "Valeur d'échantillonnage de courant secondaire à cinq étages de la torche de soudage 3",
	"g143": "Valeur d'échantillonnage de courant secondaire à six étages de la torche de soudage 3",
	"g144": "Valeur maximale d'échantillonnage de courant du support d'électrode 3 secondaire",
	"g145": "Valeur minimale d'affichage du courant du support d'électrode 3 secondaire",
	"g146": "Valeur d'affichage du courant secondaire du support d'électrode 3",
	"g147": "Valeur d'affichage du courant secondaire du support d'électrode 3",
	"g148": "Valeur d'affichage du courant secondaire à trois étages de la torche de soudage 3",
	"g149": "Valeur d'affichage du courant secondaire à quatre étages de la torche de soudage 3",
	"g150": "Valeur d'affichage du courant à cinq étages pour le support d'électrode 3 côté secondaire",
	"g151": "Valeur d'affichage du courant secondaire à six étages du porte-électrode 3",
	"g152": "Valeur d'affichage du courant secondaire maximum du support d'électrode",
	"g153": "Valeur minimale de réglage de sortie de courant primaire PWM pour le support d'électrode 4",
	"g154": "Valeur de réglage de sortie PWM de courant primaire pour le support d'électrode 4, section 1",
	"g155": "Valeur de réglage de sortie PWM de courant primaire secondaire de torche de soudage 4",
	"g156": "Valeur de réglage de sortie de courant primaire PWM à trois étages de la torche de soudage 4",
	"g157": "Valeur de réglage pour la sortie PWM de courant primaire à quatre segments du support d'électrode 4",
	"g158": "Valeur de réglage de sortie de courant primaire PWM à cinq étages de la torche de soudage 4",
	"g159": "Valeur de réglage de sortie de courant primaire PWM à six étages de la torche de soudage 4",
	"g160": "Torche de soudage 4 valeur de réglage de sortie PWM de courant primaire maximum",
	"g161": "Valeur minimale d'échantillonnage de courant du support d'électrode 4 au niveau primaire",
	"g162": "Valeur d'échantillonnage courante du premier étage du porte électrode 4",
	"g163": "Valeur d'échantillonnage courante de la deuxième étape du circuit primaire des pinces de soudage 4",
	"g164": "Valeur d'échantillonnage de courant primaire à trois étapes de la torche de soudage 4",
	"g165": "Valeur d'échantillonnage courante du quatrième étage primaire du porte électrode 4",
	"g166": "Valeur d'échantillonnage courante du support d'électrode 4 au cinquième stade primaire",
	"g167": "Valeur d'échantillonnage courante du support d'électrode 4 au cours des six premiers étages",
	"g168": "Valeur maximale d'échantillonnage de courant du support d'électrode 4 au niveau primaire",
	"g169": "Valeur d'affichage du courant minimum primaire de la torche de soudage 4",
	"g170": "Valeur d'affichage courante de la section primaire 1 du support d'électrode 4",
	"g171": "Valeur d'affichage du courant primaire à deux étages pour le support d'électrode 4",
	"g172": "Valeur d'affichage du courant principal à trois étages du support d'électrode 4",
	"g173": "Valeur d'affichage du courant primaire à quatre étages du support d'électrode 4",
	"g174": "Valeur d'affichage du courant primaire à cinq étages de la torche de soudage 4",
	"g175": "Valeur d'affichage du courant primaire à six étages de la torche de soudage 4",
	"g176": "Valeur d'affichage du courant primaire maximum pour les pinces de soudage 4",
	"g177": "Valeur minimale de réglage de sortie de courant secondaire PWM pour le support d'électrode 4",
	"g178": "Valeur de réglage de sortie PWM de courant secondaire pour le support d'électrode 4, section 1",
	"g179": "Valeur de réglage de sortie de courant secondaire PWM pour la torche de soudage 4, section 2",
	"g180": "Valeur de réglage de sortie de courant secondaire PWM à trois étages de la torche de soudage 4",
	"g181": "Valeur de réglage pour la sortie PWM du courant secondaire à quatre étages des pinces de soudage 4",
	"g182": "Valeur de réglage de sortie de courant secondaire PWM à cinq étages de la torche de soudage 4",
	"g183": "Valeur de réglage de sortie de courant secondaire PWM à six étages de la torche de soudage 4",
	"g184": "Torche de soudage 4 valeur de réglage de sortie PWM de courant secondaire maximum",
	"g185": "Valeur minimale d'échantillonnage de courant du support d'électrode 4 secondaire",
	"g186": "Valeur d'échantillonnage de courant secondaire de la torche de soudage 4",
	"g187": "Valeur d'échantillonnage de courant secondaire du support d'électrode 4",
	"g188": "Valeur d'échantillonnage de courant secondaire à trois étages de la torche de soudage 4",
	"g189": "Valeur d'échantillonnage de courant secondaire à quatre étages de la torche de soudage 4",
	"g190": "Valeur d'échantillonnage de courant secondaire à cinq étages de la torche de soudage 4",
	"g191": "Pinces de soudage 4 valeurs d'échantillonnage de courant secondaire à six étages",
	"g192": "Valeur maximale d'échantillonnage de courant du support d'électrode 4 côté secondaire",
	"g193": "Valeur d'affichage du courant minimum secondaire de la torche de soudage 4",
	"g194": "Valeur d'affichage du courant secondaire du support d'électrode 4",
	"g195": "Valeur d'affichage du courant secondaire à deux étages du support d'électrode 4",
	"g196": "Valeur d'affichage du courant secondaire à trois étages de la torche de soudage 4",
	"g197": "Valeur d'affichage du courant secondaire à quatre étages de la torche de soudage 4",
	"g198": "Valeur d'affichage du courant secondaire à cinq étages de la torche de soudage 4",
	"g199": "Valeur d'affichage du courant secondaire à six étages de la torche de soudage 4",
	"g200": "Valeur d'affichage de courant maximum du support d'électrode 4 secondaire",
	"g201": "Valeur minimale de réglage de sortie de courant primaire PWM pour les pinces de soudage 5",
	"g202": "Valeur de réglage de sortie PWM de courant primaire pour le support d'électrode 5, section 1",
	"g203": "Valeur de réglage de sortie PWM de courant primaire secondaire de torche de soudage 5",
	"g204": "Valeur de réglage de sortie de courant primaire PWM à trois étages de la torche de soudage 5",
	"g205": "Valeur de réglage pour la sortie de courant primaire PWM à quatre étages des pinces de soudage 5",
	"g206": "Valeur de réglage de sortie de courant primaire PWM à cinq étages de la torche de soudage 5",
	"g207": "Valeur de réglage de sortie de courant primaire PWM à six étages de la torche de soudage 5",
	"g208": "Valeur de réglage maximale de sortie de courant primaire PWM pour le support d'électrode 5",
	"g209": "Valeur minimale d'échantillonnage de courant du support d'électrode 5 au niveau primaire",
	"g210": "Valeur d'échantillonnage courante de la section primaire du porte électrode 5",
	"g211": "Valeur d'échantillonnage courante du support d'électrode 5 à l'étape secondaire primaire",
	"g212": "Valeur d'échantillonnage du courant primaire à trois étapes de la torche de soudage 5",
	"g213": "Valeur d'échantillonnage courante de la quatrième étape du circuit primaire des pinces de soudage 5",
	"g214": "Valeur d'échantillonnage courante du support d'électrode 5 au cinquième stade primaire",
	"g215": "Valeur d'échantillonnage du courant primaire à six étages de la torche de soudage 5",
	"g216": "Valeur maximale d'échantillonnage de courant du support d'électrode 5 au niveau primaire",
	"g217": "Valeur d'affichage du courant primaire minimum pour le support d'électrode 5",
	"g218": "Valeur d'affichage courante de la section primaire 1 du porte-électrode 5",
	"g219": "Valeur d'affichage du courant primaire à deux étages de la torche de soudage 5",
	"g220": "Valeur d'affichage du courant principal à trois étages de la torche de soudage 5",
	"g221": "Valeur d'affichage du courant principal à quatre étages de la torche de soudage 5",
	"g222": "Torche de soudage 5, valeur d'affichage de courant primaire à cinq étages",
	"g223": "Valeur d'affichage du courant primaire à six étages de la torche de soudage 5",
	"g224": "Torche de soudage 5 valeur d'affichage du courant maximum primaire",
	"g225": "Valeur minimale de réglage de sortie de courant secondaire PWM pour le support d'électrode 5",
	"g226": "Valeur de réglage de sortie PWM de courant secondaire pour le support d'électrode 5, section 1",
	"g227": "Valeur de réglage de sortie PWM de courant secondaire de torche de soudage 5",
	"g228": "Valeur de réglage de sortie de courant secondaire PWM à trois étages de la torche de soudage 5",
	"g229": "Valeur de réglage de sortie de courant secondaire PWM à quatre étages de la torche de soudage 5",
	"g230": "Valeur de réglage de sortie de courant secondaire PWM à cinq étages de la torche de soudage 5",
	"g231": "Valeur de réglage de sortie de courant secondaire PWM à six étages de la torche de soudage 5",
	"g232": "Torche de soudage 5 valeur de réglage de sortie PWM de courant secondaire maximum",
	"g233": "Valeur minimale d'échantillonnage de courant du support d'électrode 5 secondaire",
	"g234": "Valeur d'échantillonnage de courant secondaire de la torche de soudage 5",
	"g235": "Valeur d'échantillonnage de courant secondaire du support d'électrode 5",
	"g236": "Valeur d'échantillonnage de courant secondaire à trois étages de la torche de soudage 5",
	"g237": "Valeur d'échantillonnage de courant secondaire à quatre segments du porte-électrode 5",
	"g238": "Valeur d'échantillonnage de courant secondaire à cinq étages de la torche de soudage 5",
	"g239": "Valeur d'échantillonnage de courant secondaire à six étages de la torche de soudage 5",
	"g240": "Valeur maximale d'échantillonnage du courant du côté secondaire des pinces de soudage",
	"g241": "Valeur d'affichage du courant minimum secondaire de la torche de soudage 5",
	"g242": "Valeur d'affichage du courant secondaire du support d'électrode 5",
	"g243": "Valeur d'affichage du courant secondaire à deux étages de la torche de soudage 5",
	"g244": "Valeur d'affichage du courant secondaire à trois étages de la torche de soudage 5",
	"g245": "Valeur d'affichage du courant secondaire à quatre étages de la torche de soudage 5",
	"g246": "Valeur d'affichage du courant secondaire à cinq étages de la torche de soudage 5",
	"g247": "Valeur d'affichage du courant secondaire à six étages de la torche de soudage 5",
	"g248": "Valeur d'affichage du courant maximum secondaire de la torche de soudage 5",
	"g249": "Torche de soudage 3 paramètre de coupe à courant constant primaire",
	"g250": "Type non défini: {{.a}}",
	"g251": "Valeur de réglage de sortie de pression pour un segment d'électrode 3 des pinces de soudage",
	"g252": "Valeur de sortie de pression pour la deuxième section de l'électrode 3 des pinces de soudage",
	"g253": "Valeur d'affichage de pression mesurée d'un segment de l'électrode 3 des pinces de soudage",
	"g254": "Valeur mesurée de l'affichage de pression pour la deuxième section de l'électrode 3 de la torche de soudage",
	"g255": "Valeur de réglage de sortie de pression pour un segment d'électrode 4 des pinces de soudage",
	"g256": "Valeur définie pour la sortie de pression à deux étages de l'électrode 4 des pinces de soudage",
	"g257": "Valeur mesurée réelle de l'affichage de pression pour une section de l'électrode 4 des pinces de soudage",
	"g258": "Valeur mesurée de l'affichage de pression pour la deuxième section de l'électrode 4 des pinces de soudage",
	"g259": "Valeur de réglage de la sortie de pression pour un segment de l'électrode 5 de la torche de soudage",
	"g260": "Valeur de réglage de la sortie de pression à deux étages pour l'électrode 5 des pinces de soudage",
	"g261": "Valeur d'affichage de pression mesurée d'un segment de l'électrode 5 des pinces de soudage",
	"g262": "Valeur mesurée de l'affichage de pression pour la deuxième section de l'électrode 5 des pinces de soudage",
	"d001": "Rafraîchir la quantité",
	"d002": "Le numéro de mappage du point de soudure ne peut pas être vide et doit être un entier uniquement",
	"d003": "Le numéro de norme ne peut pas être vide et doit être un entier uniquement",
	"d004": "La pression ne peut pas être vide et doit être un nombre entier uniquement",
	"d005": "L'épaisseur de la plaque ne peut pas être vide et doit être un nombre décimal (plage de valeurs de 0 à 99999.99)",
	"d006": "X ne peut pas être vide et doit être un nombre décimal (plage de valeurs de 0 à 999.99)",
	"d007": "Y ne peut pas être vide et doit être un nombre décimal (plage de valeurs de 0 à 999.99)",
	"d008": "Z ne peut pas être vide et ne peut être qu'un nombre décimal (plage de valeurs de 0 à 999,99)",
	"d009": "L'épaisseur de la plaque 1 ne peut être qu'un nombre décimal (plage de valeurs de 0 à 99999,99)",
	"d010": "L'épaisseur de la plaque 2 ne peut être qu'une décimale (plage de valeurs de 0 à 99999.99)",
	"d011": "L'épaisseur de la plaque 3 ne peut être qu'un nombre décimal (plage de valeurs de 0 à 99999.99)",
	"d012": "L'épaisseur de la plaque 4 ne peut être qu'un nombre décimal (plage de valeurs de 0 à 99999.99)",
	"d013": "Les données supprimées ne peuvent pas être récupérées. Êtes-vous sûr de vouloir les supprimer ? ",
	"d014": "Enregistrement des paramètres du système",
	"d015": "Enregistrement de la gestion des points de soudure",
	"d016": "Type d'opération",
	"d017": "Nouveau",
	"d018": "Modifier",
	"d019": "Comparaison des paramètres",
	"d020": "L'opérateur n'existe pas, impossible de consulter",
	"d021": "La valeur de configuration est manquante ou anormale",
	"d022": "Quantité importée",
	"d023": "Calcul en cours du nombre",
	"d024": "Vérifier la quantité",
	"d025": "Effacer la quantité",
	"d026": "Quantité de téléchargement",
	"d027": "Données effacées avec succès",
	"d028": "Échec de l'effacement des données",
	"d029": "Actualisation des joints de soudure",
	"d030": "Confirmez-vous l'actualisation des joints de soudure sur le périphérique sélectionné ?",
	"d031": "Une erreur s'est produite lors de l'actualisation des joints de soudure et l'opération ne peut pas se poursuivre",
	"d032": "Actualisation des joints de soudure annulée",
	"d033": "Le périphérique est hors ligne ; cette opération ne peut pas être effectuée.",
	"d034": "Actualisation des joints de soudure réussie",
	"d035": "Aperçu de la progression de l'actualisation des joints de soudure",
	"d036": "Détails de l'actualisation des joints de soudure",
	"d037": "Progression de l'actualisation des joints de soudure",
	"d038": "Actualisation des joints de soudure en cours",
	"d039": "Échec de l'actualisation des joints de soudure",
	"d040": "L'annulation de l'actualisation des joints de soudure interrompra les opérations suivantes. Voulez-vous vraiment continuer ?",
	"d041": "La tâche de soudure a été réessayée. ",
	"e001": "Statistiques sur les projections",
	"e002": "Affichage des statistiques sur les projections",
	"e003": "Gestion des statistiques sur les projections",
	"e004": "Dimensions de la requête",
	"e005": "Joints de soudure",
	"e006": "Erreur de dimension de la requête",
	"e007": "Valeur du nombre d'éclaboussures",
	"e008": "Valeur du nombre de joints de soudure",
	"e009": "Valeur du nombre total",
	"e010": "Taux d'acceptation des éclaboussures",
	"e011": "Vue des données",
	"e012": "Erreur lors de l'obtention des données du modèle de véhicule",
	"e013": "Filtrage des points de soudure, plusieurs points séparés par ,",
	"e014": "Filtrage standard, plusieurs séparés par ,",
	"e015": "Cliquez pour copier",
	"e016": "Numéro de série",
	"e017": "<p>1、Vous pouvez sélectionner différentes dimensions pour interroger le taux de projection, puis cliquez sur \"Interroger\" après votre sélection. </p><p>2、Après avoir choisi la zone/équipement/modèle de véhicule/point de soudure/specification, vous pouvez sélectionner les différentes zones/équipements/modèles de véhicule dans la liste à gauche pour effectuer une nouvelle recherche. </p><p>3、Après avoir sélectionné le point de soudure/specification, vous pouvez saisir dans la barre de recherche les points de soudure/specification que vous souhaitez filtrer pour une nouvelle interrogation (séparés par une virgule s'il y en a plusieurs).",
	"e018": "usine",
	"e019": "Enregistrement des projections",
	"e020": "Effacer la requête",
	"e021": "Exportation terminée",
	"e022": "Début de l'exportation des spécifications",
	"e023": "Exportation des spécifications",
	"e024": "Début de la synchronisation",
	"e025": "Synchronisation en cours",
	"e026": "Début de l'importation des spécifications",
	"e027": "Importation des spécifications",
	"e028": "Erreur d'écriture des spécifications",
	"e029": "Numéro de spécification de début",
	"e030": "Numéro de spécification de fin",
	"e031": "Convertir le numéro d'identification du véhicule (VIN) en numéro de série",
	"e032": "Veuillez saisir la plage du numéro d'identification du véhicule (VIN)",
	"e033": "Le numéro d'identification du véhicule (VIN) doit être un nombre entier",
	"e034": "La valeur UIP doit être un nombre entier supérieur à 0",
	"e035": "Prend en charge le filtrage inversé du contenu des alarmes ; par exemple, « !Soudage 1 dépassement de limite de courant » filtrera les enregistrements contenant « Soudage 1 dépassement de limite de courant »."
}